/* tslint:disable */
/* eslint-disable */
/**
 * Multi-tenancy tracker API
 * API documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 *
 * @export
 * @interface AccessTokenOnlyDto
 */
export interface AccessTokenOnlyDto {
  /**
   *
   * @type {string}
   * @memberof AccessTokenOnlyDto
   */
  access_token?: string;
}
/**
 *
 * @export
 * @interface AddTransactionDto
 */
export interface AddTransactionDto {
  /**
   *
   * @type {Array<CreateTransactionServiceDto>}
   * @memberof AddTransactionDto
   */
  service?: Array<CreateTransactionServiceDto>;
  /**
   *
   * @type {Array<CreateTransactionAddonDto>}
   * @memberof AddTransactionDto
   */
  addon?: Array<CreateTransactionAddonDto>;
  /**
   *
   * @type {boolean}
   * @memberof AddTransactionDto
   */
  is_paid?: boolean;
}
/**
 *
 * @export
 * @interface AllMemberDto
 */
export interface AllMemberDto {
  /**
   *
   * @type {boolean}
   * @memberof AllMemberDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof AllMemberDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof AllMemberDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof AllMemberDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  parent_code?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  subscription?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  subscription_start_date?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  subscription_end_date?: string;
  /**
   *
   * @type {boolean}
   * @memberof AllMemberDto
   */
  is_subscription?: boolean;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  service_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  service_description?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  email?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof AllMemberDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof AllMemberDto
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof AllMemberDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof AllMemberDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof AllMemberDto
   */
  latitude?: number;
  /**
   *
   * @type {boolean}
   * @memberof AllMemberDto
   */
  is_child?: boolean;
}
/**
 *
 * @export
 * @interface AuthenticationControllerAuthenticate201Response
 */
export interface AuthenticationControllerAuthenticate201Response {
  /**
   *
   * @type {string}
   * @memberof AuthenticationControllerAuthenticate201Response
   */
  message?: string;
  /**
   *
   * @type {TokenDto}
   * @memberof AuthenticationControllerAuthenticate201Response
   */
  data?: TokenDto;
}
/**
 *
 * @export
 * @interface AuthenticationControllerRefreshRenew201Response
 */
export interface AuthenticationControllerRefreshRenew201Response {
  /**
   *
   * @type {string}
   * @memberof AuthenticationControllerRefreshRenew201Response
   */
  message?: string;
  /**
   *
   * @type {RenewRefreshTokenDto}
   * @memberof AuthenticationControllerRefreshRenew201Response
   */
  data?: RenewRefreshTokenDto;
}
/**
 *
 * @export
 * @interface BlockPersonDto
 */
export interface BlockPersonDto {
  /**
   *
   * @type {boolean}
   * @memberof BlockPersonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof BlockPersonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof BlockPersonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof BlockPersonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  code: string;
  /**
   * IF set as TRUE then the user will not be allowed to login ELSE the user will still be allowed to login.
   * @type {boolean}
   * @memberof BlockPersonDto
   */
  is_blocked?: boolean;
}
/**
 *
 * @export
 * @interface CoreApiPaginatedResponse
 */
export interface CoreApiPaginatedResponse {
  /**
   *
   * @type {number}
   * @memberof CoreApiPaginatedResponse
   */
  count?: number;
}
/**
 *
 * @export
 * @interface CreateAttachmentTypeDto
 */
export interface CreateAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateBranchDto
 */
export interface CreateBranchDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateBranchDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateBranchDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateBranchDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateBranchDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  head?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBranchDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface CreateConfigDto
 */
export interface CreateConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface CreateItemDto
 */
export interface CreateItemDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof CreateItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  tenant?: string;
  /**
   *
   * @type {number}
   * @memberof CreateItemDto
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface CreateMemberDto
 */
export interface CreateMemberDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateMemberDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateMemberDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateMemberDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateMemberDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  parent_code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  email?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof CreateMemberDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateMemberDto
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof CreateMemberDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof CreateMemberDto
   */
  latitude?: number;
  /**
   *
   * @type {boolean}
   * @memberof CreateMemberDto
   */
  is_child?: boolean;
}
/**
 *
 * @export
 * @interface CreatePaymentDto
 */
export interface CreatePaymentDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePaymentDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentDto
   */
  tenant?: string;
  /**
   * JANUARY, FEBRUARY, ...
   * @type {string}
   * @memberof CreatePaymentDto
   */
  p_month?: string;
  /**
   * 2023, 2024...
   * @type {number}
   * @memberof CreatePaymentDto
   */
  p_year: number;
  /**
   * PENDING | VERIFIED | REJECTED | CANCELLED
   * @type {string}
   * @memberof CreatePaymentDto
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentDto
   */
  remarks?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentDto
   */
  attachment?: string;
  /**
   *
   * @type {number}
   * @memberof CreatePaymentDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof CreatePaymentDto
   */
  overdue?: number;
}
/**
 *
 * @export
 * @interface CreatePersonAddressDto
 */
export interface CreatePersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  user_code: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof CreatePersonAddressDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof CreatePersonAddressDto
   */
  latitude?: number;
}
/**
 *
 * @export
 * @interface CreatePersonExtendedDto
 */
export interface CreatePersonExtendedDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonExtendedDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonExtendedDto
   */
  is_verified?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  activation_code?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  birthday?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonExtendedDto
   */
  is_blocked?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  father_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  mother_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  sss?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  philhealth?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  pagibig?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  tin?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  medical_condition?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  blood_type?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  elementary?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  high_school?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  college?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  post_college?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  undergraduate?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  curriculum_vitae?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  supporting_doc?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  intent_letter?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  application_letter?: string;
  /**
   *
   * @type {CreatePersonAddressDto}
   * @memberof CreatePersonExtendedDto
   */
  address?: CreatePersonAddressDto;
}
/**
 *
 * @export
 * @interface CreateRequestTypeDto
 */
export interface CreateRequestTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateRequestTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateRequestTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateRewardDto
 */
export interface CreateRewardDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateRewardDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRewardDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRewardDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRewardDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRewardDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRewardDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRewardDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRewardDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRewardDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRewardDto
   */
  reward_type: string;
  /**
   *
   * @type {number}
   * @memberof CreateRewardDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof CreateRewardDto
   */
  points: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateRewardDto
   */
  start_date: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateRewardDto
   */
  end_date: string;
  /**
   *
   * @type {string}
   * @memberof CreateRewardDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateServiceDto
 */
export interface CreateServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateServiceDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateServiceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateServiceDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof CreateServiceDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof CreateServiceDto
   */
  duration?: number;
  /**
   *
   * @type {boolean}
   * @memberof CreateServiceDto
   */
  is_open_time?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateServiceDto
   */
  upgrade: number;
  /**
   *
   * @type {string}
   * @memberof CreateServiceDto
   */
  tenant?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateServiceDto
   */
  is_subscription?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateServiceDto
   */
  days: number;
}
/**
 *
 * @export
 * @interface CreateStatusDto
 */
export interface CreateStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateStatusDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateStatusDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateStatusDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateSubscriptionDto
 */
export interface CreateSubscriptionDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateSubscriptionDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  member: string;
  /**
   *
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  service: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  start_date?: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof CreateSubscriptionDto
   */
  end_date?: string;
  /**
   *
   * @type {number}
   * @memberof CreateSubscriptionDto
   */
  amount?: number;
  /**
   *
   * @type {boolean}
   * @memberof CreateSubscriptionDto
   */
  is_subscription?: boolean;
}
/**
 *
 * @export
 * @interface CreateTenantDto
 */
export interface CreateTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  business_name: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  business_type: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  phone_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  website: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateTenantDto
   */
  membership_date?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  rewards_type?: string;
  /**
   * MONTHLY | QUARTERLY | ANNUALLY
   * @type {string}
   * @memberof CreateTenantDto
   */
  subscription_type?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateTenantDto
   */
  start_date?: string;
  /**
   *
   * @type {number}
   * @memberof CreateTenantDto
   */
  amount?: number;
  /**
   * X number of days after expected payment date
   * @type {number}
   * @memberof CreateTenantDto
   */
  grace_period?: number;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  slug?: string;
}
/**
 *
 * @export
 * @interface CreateTransactionAddonDto
 */
export interface CreateTransactionAddonDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateTransactionAddonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionAddonDto
   */
  item: string;
  /**
   *
   * @type {number}
   * @memberof CreateTransactionAddonDto
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof CreateTransactionAddonDto
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface CreateTransactionServiceDto
 */
export interface CreateTransactionServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateTransactionServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  member: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  service: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  date?: string;
  /**
   * 23:59 - Military Time
   * @type {string}
   * @memberof CreateTransactionServiceDto
   */
  time?: string;
  /**
   *
   * @type {number}
   * @memberof CreateTransactionServiceDto
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface CreateTransactionWaiverBaseDto
 */
export interface CreateTransactionWaiverBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateTransactionWaiverBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  waiver?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  subscription?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTransactionWaiverBaseDto
   */
  signature?: string;
}
/**
 *
 * @export
 * @interface CreateWaiverDto
 */
export interface CreateWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof CreateWaiverDto
   */
  font_size: number;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  sub_title?: string;
}
/**
 *
 * @export
 * @interface DashboardDto
 */
export interface DashboardDto {
  /**
   *
   * @type {number}
   * @memberof DashboardDto
   */
  value?: number;
  /**
   *
   * @type {string}
   * @memberof DashboardDto
   */
  label?: string;
  /**
   *
   * @type {Array<MiniTransactionDto>}
   * @memberof DashboardDto
   */
  metadata?: Array<MiniTransactionDto>;
}
/**
 *
 * @export
 * @interface DeleteAttachmentTypeDto
 */
export interface DeleteAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteBranchDto
 */
export interface DeleteBranchDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteBranchDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteBranchDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBranchDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteBranchDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBranchDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteBranchDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBranchDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBranchDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteConfigDto
 */
export interface DeleteConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteItemDto
 */
export interface DeleteItemDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteMemberDto
 */
export interface DeleteMemberDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteMemberDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteMemberDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteMemberDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteMemberDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteMemberDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteMemberDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteMemberDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteMemberDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeletePaymentDto
 */
export interface DeletePaymentDto {
  /**
   *
   * @type {boolean}
   * @memberof DeletePaymentDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePaymentDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePaymentDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePaymentDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeletePersonAddressDto
 */
export interface DeletePersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof DeletePersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeletePersonDto
 */
export interface DeletePersonDto {
  /**
   *
   * @type {boolean}
   * @memberof DeletePersonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteRequestTypeDto
 */
export interface DeleteRequestTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteRequestTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRequestTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRequestTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRequestTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRequestTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRequestTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRequestTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRequestTypeDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteRewardDto
 */
export interface DeleteRewardDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteRewardDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRewardDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRewardDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRewardDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRewardDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRewardDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRewardDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRewardDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteRoleDto
 */
export interface DeleteRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteServiceDto
 */
export interface DeleteServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteServiceDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteStatusDto
 */
export interface DeleteStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteStatusDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteSubscriptionDto
 */
export interface DeleteSubscriptionDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteSubscriptionDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteSubscriptionDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteSubscriptionDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteSubscriptionDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteSubscriptionDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteSubscriptionDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteSubscriptionDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteSubscriptionDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteTenantDto
 */
export interface DeleteTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteTransactionAddonDto
 */
export interface DeleteTransactionAddonDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteTransactionAddonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionAddonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionAddonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionAddonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionAddonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionAddonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionAddonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionAddonDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteTransactionDto
 */
export interface DeleteTransactionDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteTransactionDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteTransactionServiceDto
 */
export interface DeleteTransactionServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteTransactionServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionServiceDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteTransactionWaiverDto
 */
export interface DeleteTransactionWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteTransactionWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTransactionWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTransactionWaiverDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteWaiverDto
 */
export interface DeleteWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeviceAuthorization
 */
export interface DeviceAuthorization {
  /**
   *
   * @type {boolean}
   * @memberof DeviceAuthorization
   */
  authorize: boolean;
}
/**
 *
 * @export
 * @interface DeviceRegistrationControllerRegister201Response
 */
export interface DeviceRegistrationControllerRegister201Response {
  /**
   *
   * @type {string}
   * @memberof DeviceRegistrationControllerRegister201Response
   */
  message?: string;
  /**
   *
   * @type {AccessTokenOnlyDto}
   * @memberof DeviceRegistrationControllerRegister201Response
   */
  data?: AccessTokenOnlyDto;
}
/**
 *
 * @export
 * @interface EditAttachmentTypeDto
 */
export interface EditAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof EditAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface EditBranchDto
 */
export interface EditBranchDto {
  /**
   *
   * @type {boolean}
   * @memberof EditBranchDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditBranchDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditBranchDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditBranchDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  head?: string;
  /**
   *
   * @type {string}
   * @memberof EditBranchDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface EditConfigDto
 */
export interface EditConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof EditConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface EditItemDto
 */
export interface EditItemDto {
  /**
   *
   * @type {boolean}
   * @memberof EditItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof EditItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  tenant?: string;
  /**
   *
   * @type {number}
   * @memberof EditItemDto
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface EditMemberDto
 */
export interface EditMemberDto {
  /**
   *
   * @type {boolean}
   * @memberof EditMemberDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditMemberDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditMemberDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditMemberDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  parent_code?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  email?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof EditMemberDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditMemberDto
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof EditMemberDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof EditMemberDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof EditMemberDto
   */
  latitude?: number;
  /**
   *
   * @type {boolean}
   * @memberof EditMemberDto
   */
  is_child?: boolean;
}
/**
 *
 * @export
 * @interface EditPaymentDto
 */
export interface EditPaymentDto {
  /**
   *
   * @type {boolean}
   * @memberof EditPaymentDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPaymentDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPaymentDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPaymentDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentDto
   */
  tenant?: string;
  /**
   * JANUARY, FEBRUARY, ...
   * @type {string}
   * @memberof EditPaymentDto
   */
  p_month?: string;
  /**
   * 2023, 2024...
   * @type {number}
   * @memberof EditPaymentDto
   */
  p_year: number;
  /**
   * PENDING | VERIFIED | REJECTED | CANCELLED
   * @type {string}
   * @memberof EditPaymentDto
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentDto
   */
  remarks?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentDto
   */
  attachment?: string;
  /**
   *
   * @type {number}
   * @memberof EditPaymentDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof EditPaymentDto
   */
  overdue?: number;
}
/**
 *
 * @export
 * @interface EditPersonAddressDto
 */
export interface EditPersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof EditPersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof EditPersonAddressDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof EditPersonAddressDto
   */
  latitude?: number;
}
/**
 *
 * @export
 * @interface EditPersonExtendedDto
 */
export interface EditPersonExtendedDto {
  /**
   *
   * @type {boolean}
   * @memberof EditPersonExtendedDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPersonExtendedDto
   */
  is_verified?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  activation_code?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  birthday?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPersonExtendedDto
   */
  is_blocked?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  father_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  mother_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  sss?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  philhealth?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  pagibig?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  tin?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  medical_condition?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  blood_type?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  elementary?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  high_school?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  college?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  post_college?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  undergraduate?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  curriculum_vitae?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  supporting_doc?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  intent_letter?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  application_letter?: string;
  /**
   *
   * @type {EditPersonAddressDto}
   * @memberof EditPersonExtendedDto
   */
  address?: EditPersonAddressDto;
}
/**
 *
 * @export
 * @interface EditRequestTypeDto
 */
export interface EditRequestTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof EditRequestTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditRequestTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface EditRewardDto
 */
export interface EditRewardDto {
  /**
   *
   * @type {boolean}
   * @memberof EditRewardDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRewardDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRewardDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRewardDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRewardDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRewardDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRewardDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditRewardDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditRewardDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditRewardDto
   */
  reward_type: string;
  /**
   *
   * @type {number}
   * @memberof EditRewardDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof EditRewardDto
   */
  points: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditRewardDto
   */
  start_date: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditRewardDto
   */
  end_date: string;
  /**
   *
   * @type {string}
   * @memberof EditRewardDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface EditRoleDto
 */
export interface EditRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof EditRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface EditServiceDto
 */
export interface EditServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof EditServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditServiceDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditServiceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditServiceDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof EditServiceDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof EditServiceDto
   */
  duration?: number;
  /**
   *
   * @type {boolean}
   * @memberof EditServiceDto
   */
  is_open_time?: boolean;
  /**
   *
   * @type {number}
   * @memberof EditServiceDto
   */
  upgrade: number;
  /**
   *
   * @type {string}
   * @memberof EditServiceDto
   */
  tenant?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditServiceDto
   */
  is_subscription?: boolean;
  /**
   *
   * @type {number}
   * @memberof EditServiceDto
   */
  days: number;
}
/**
 *
 * @export
 * @interface EditStatusDto
 */
export interface EditStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof EditStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditStatusDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditStatusDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditStatusDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface EditSubscriptionDto
 */
export interface EditSubscriptionDto {
  /**
   *
   * @type {boolean}
   * @memberof EditSubscriptionDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  member?: string;
  /**
   *
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  service: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  start_date?: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof EditSubscriptionDto
   */
  end_date?: string;
  /**
   *
   * @type {number}
   * @memberof EditSubscriptionDto
   */
  amount?: number;
  /**
   *
   * @type {boolean}
   * @memberof EditSubscriptionDto
   */
  is_subscription?: boolean;
}
/**
 *
 * @export
 * @interface EditTenantDto
 */
export interface EditTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof EditTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  business_name: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  business_type: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  phone_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  website: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditTenantDto
   */
  membership_date?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  rewards_type?: string;
  /**
   * MONTHLY | QUARTERLY | ANNUALLY
   * @type {string}
   * @memberof EditTenantDto
   */
  subscription_type?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditTenantDto
   */
  start_date?: string;
  /**
   *
   * @type {number}
   * @memberof EditTenantDto
   */
  amount?: number;
  /**
   * X number of days after expected payment date
   * @type {number}
   * @memberof EditTenantDto
   */
  grace_period?: number;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  slug?: string;
}
/**
 *
 * @export
 * @interface EditTransactionAddonDto
 */
export interface EditTransactionAddonDto {
  /**
   *
   * @type {boolean}
   * @memberof EditTransactionAddonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionAddonDto
   */
  item: string;
  /**
   *
   * @type {number}
   * @memberof EditTransactionAddonDto
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof EditTransactionAddonDto
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface EditTransactionDto
 */
export interface EditTransactionDto {
  /**
   *
   * @type {boolean}
   * @memberof EditTransactionDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  remarks?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditTransactionDto
   */
  is_paid?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditTransactionDto
   */
  is_subscription?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditTransactionDto
   */
  subscription?: string;
}
/**
 *
 * @export
 * @interface EditTransactionServiceDto
 */
export interface EditTransactionServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof EditTransactionServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  batch?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  member?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  service: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  date?: string;
  /**
   * 23:59 - Military Time
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  time?: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  checkout_date?: string;
  /**
   * 23:59 - Military Time
   * @type {string}
   * @memberof EditTransactionServiceDto
   */
  checkout_time?: string;
  /**
   *
   * @type {number}
   * @memberof EditTransactionServiceDto
   */
  amount?: number;
  /**
   *
   * @type {boolean}
   * @memberof EditTransactionServiceDto
   */
  is_checkout?: boolean;
}
/**
 *
 * @export
 * @interface EditTransactionWaiverBaseDto
 */
export interface EditTransactionWaiverBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof EditTransactionWaiverBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  waiver?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  subscription?: string;
  /**
   *
   * @type {string}
   * @memberof EditTransactionWaiverBaseDto
   */
  signature?: string;
}
/**
 *
 * @export
 * @interface EditWaiverDto
 */
export interface EditWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof EditWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof EditWaiverDto
   */
  font_size: number;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  sub_title?: string;
}
/**
 *
 * @export
 * @interface GenericErrorResponseDto
 */
export interface GenericErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof GenericErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof GenericErrorResponseDto
   */
  status_code?: number;
}
/**
 *
 * @export
 * @interface GetAddonDto
 */
export interface GetAddonDto {
  /**
   *
   * @type {string}
   * @memberof GetAddonDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetAddonDto
   */
  item?: string;
  /**
   *
   * @type {string}
   * @memberof GetAddonDto
   */
  item_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAddonDto
   */
  item_description: string;
  /**
   *
   * @type {number}
   * @memberof GetAddonDto
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof GetAddonDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof GetAddonDto
   */
  sub_total?: number;
  /**
   *
   * @type {number}
   * @memberof GetAddonDto
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface GetAttachmentTypeDto
 */
export interface GetAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof GetAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface GetBillingDto
 */
export interface GetBillingDto {
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  business_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  avatar?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetBillingDto
   */
  membership_date?: string;
  /**
   * MONTHLY | QUARTERLY | ANNUALLY
   * @type {string}
   * @memberof GetBillingDto
   */
  subscription_type?: string;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  amount?: number;
  /**
   * X number of days after expected payment date
   * @type {number}
   * @memberof GetBillingDto
   */
  grace_period?: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetBillingDto
   */
  billing_date?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetBillingDto
   */
  termination_date?: string;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  billable_amount?: number;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  payment_code?: string;
  /**
   * PENDING | VERIFIED | REJECTED | CANCELLED
   * @type {string}
   * @memberof GetBillingDto
   */
  payment_status: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetBillingDto
   */
  paid_at?: string;
}
/**
 *
 * @export
 * @interface GetBranchDto
 */
export interface GetBranchDto {
  /**
   *
   * @type {boolean}
   * @memberof GetBranchDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetBranchDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetBranchDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetBranchDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  head?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  head_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  head_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  head_last_name: string;
  /**
   *
   * @type {number}
   * @memberof GetBranchDto
   */
  population?: number;
  /**
   *
   * @type {string}
   * @memberof GetBranchDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface GetConfigDto
 */
export interface GetConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof GetConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface GetItemDto
 */
export interface GetItemDto {
  /**
   *
   * @type {boolean}
   * @memberof GetItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof GetItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  tenant?: string;
  /**
   *
   * @type {number}
   * @memberof GetItemDto
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface GetMemberChildDto
 */
export interface GetMemberChildDto {
  /**
   *
   * @type {boolean}
   * @memberof GetMemberChildDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetMemberChildDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetMemberChildDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetMemberChildDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  parent_code?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  parent_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  parent_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  parent_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  email?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof GetMemberChildDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetMemberChildDto
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberChildDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof GetMemberChildDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof GetMemberChildDto
   */
  latitude?: number;
  /**
   *
   * @type {boolean}
   * @memberof GetMemberChildDto
   */
  is_child?: boolean;
}
/**
 *
 * @export
 * @interface GetMemberDto
 */
export interface GetMemberDto {
  /**
   *
   * @type {boolean}
   * @memberof GetMemberDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetMemberDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetMemberDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetMemberDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  parent_code?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  subscription?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  subscription_start_date?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  subscription_end_date?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetMemberDto
   */
  is_subscription?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  service_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  service_description?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  email?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof GetMemberDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetMemberDto
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof GetMemberDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof GetMemberDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof GetMemberDto
   */
  latitude?: number;
  /**
   *
   * @type {boolean}
   * @memberof GetMemberDto
   */
  is_child?: boolean;
  /**
   *
   * @type {Array<GetMemberDto>}
   * @memberof GetMemberDto
   */
  child: Array<GetMemberDto>;
}
/**
 *
 * @export
 * @interface GetPaymentDto
 */
export interface GetPaymentDto {
  /**
   *
   * @type {boolean}
   * @memberof GetPaymentDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPaymentDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPaymentDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPaymentDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  business_name?: string;
  /**
   * JANUARY, FEBRUARY, ...
   * @type {string}
   * @memberof GetPaymentDto
   */
  p_month?: string;
  /**
   * 2023, 2024...
   * @type {number}
   * @memberof GetPaymentDto
   */
  p_year: number;
  /**
   * PENDING | VERIFIED | REJECTED | CANCELLED
   * @type {string}
   * @memberof GetPaymentDto
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  remarks?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  attachment?: string;
  /**
   *
   * @type {number}
   * @memberof GetPaymentDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof GetPaymentDto
   */
  overdue?: number;
}
/**
 *
 * @export
 * @interface GetPersonAddressDto
 */
export interface GetPersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof GetPersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  user_code: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  person_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  person_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  person_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof GetPersonAddressDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof GetPersonAddressDto
   */
  latitude?: number;
}
/**
 *
 * @export
 * @interface GetPersonDto
 */
export interface GetPersonDto {
  /**
   *
   * @type {boolean}
   * @memberof GetPersonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  business_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  role_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  role_description: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPersonDto
   */
  is_verified?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  activation_code?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof GetPersonDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetPersonDto
   */
  birthday?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPersonDto
   */
  is_blocked?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  father_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  mother_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  sss?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  philhealth?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  pagibig?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  tin?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  medical_condition?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  blood_type?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  elementary?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  high_school?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  college?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  post_college?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  undergraduate?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  curriculum_vitae?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  supporting_doc?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  intent_letter?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  application_letter?: string;
  /**
   *
   * @type {GetPersonAddressDto}
   * @memberof GetPersonDto
   */
  address: GetPersonAddressDto;
}
/**
 *
 * @export
 * @interface GetRequestTypeDto
 */
export interface GetRequestTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof GetRequestTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetRequestTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface GetRewardDto
 */
export interface GetRewardDto {
  /**
   *
   * @type {boolean}
   * @memberof GetRewardDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRewardDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRewardDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRewardDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  reward_type: string;
  /**
   *
   * @type {number}
   * @memberof GetRewardDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof GetRewardDto
   */
  points: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetRewardDto
   */
  start_date: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetRewardDto
   */
  end_date: string;
  /**
   *
   * @type {string}
   * @memberof GetRewardDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface GetRoleDto
 */
export interface GetRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof GetRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface GetServiceDto
 */
export interface GetServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof GetServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof GetServiceDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof GetServiceDto
   */
  duration?: number;
  /**
   *
   * @type {boolean}
   * @memberof GetServiceDto
   */
  is_open_time?: boolean;
  /**
   *
   * @type {number}
   * @memberof GetServiceDto
   */
  upgrade: number;
  /**
   *
   * @type {string}
   * @memberof GetServiceDto
   */
  tenant?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetServiceDto
   */
  is_subscription?: boolean;
  /**
   *
   * @type {number}
   * @memberof GetServiceDto
   */
  days: number;
}
/**
 *
 * @export
 * @interface GetServiceV2Dto
 */
export interface GetServiceV2Dto {
  /**
   *
   * @type {boolean}
   * @memberof GetServiceV2Dto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  member?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  first_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  last_name?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  service: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  service_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  service_description: string;
  /**
   *
   * @type {number}
   * @memberof GetServiceV2Dto
   */
  duration?: number;
  /**
   *
   * @type {boolean}
   * @memberof GetServiceV2Dto
   */
  is_open_time?: boolean;
  /**
   *
   * @type {number}
   * @memberof GetServiceV2Dto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof GetServiceV2Dto
   */
  sub_total?: number;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  date?: string;
  /**
   * 23:59 - Military Time
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  time?: string;
  /**
   * 2024-12-31 | YYYY-MM-DD
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  checkout_date?: string;
  /**
   * 23:59 - Military Time
   * @type {string}
   * @memberof GetServiceV2Dto
   */
  checkout_time?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetServiceV2Dto
   */
  is_checkout?: boolean;
}
/**
 *
 * @export
 * @interface GetStatusDto
 */
export interface GetStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof GetStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetStatusDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface GetSubscriptionDto
 */
export interface GetSubscriptionDto {
  /**
   *
   * @type {boolean}
   * @memberof GetSubscriptionDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  member: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  member_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  member_middle_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  member_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  service: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  service_name: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  service_description: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  start_date: string;
  /**
   *
   * @type {string}
   * @memberof GetSubscriptionDto
   */
  end_date: string;
  /**
   *
   * @type {number}
   * @memberof GetSubscriptionDto
   */
  amount?: number;
  /**
   *
   * @type {boolean}
   * @memberof GetSubscriptionDto
   */
  is_subscription?: boolean;
}
/**
 *
 * @export
 * @interface GetTenantDto
 */
export interface GetTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof GetTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  phone_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  website: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetTenantDto
   */
  membership_date?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  rewards_type?: string;
  /**
   * MONTHLY | QUARTERLY | ANNUALLY
   * @type {string}
   * @memberof GetTenantDto
   */
  subscription_type?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetTenantDto
   */
  start_date?: string;
  /**
   *
   * @type {number}
   * @memberof GetTenantDto
   */
  amount?: number;
  /**
   * X number of days after expected payment date
   * @type {number}
   * @memberof GetTenantDto
   */
  grace_period?: number;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  slug?: string;
}
/**
 *
 * @export
 * @interface GetTransactionAddonDto
 */
export interface GetTransactionAddonDto {
  /**
   *
   * @type {boolean}
   * @memberof GetTransactionAddonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionAddonDto
   */
  item: string;
  /**
   *
   * @type {number}
   * @memberof GetTransactionAddonDto
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof GetTransactionAddonDto
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface GetTransactionDto
 */
export interface GetTransactionDto {
  /**
   *
   * @type {boolean}
   * @memberof GetTransactionDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  business_name?: string;
  /**
   *
   * @type {Array<GetServiceV2Dto>}
   * @memberof GetTransactionDto
   */
  service?: Array<GetServiceV2Dto>;
  /**
   *
   * @type {number}
   * @memberof GetTransactionDto
   */
  child_count?: number;
  /**
   *
   * @type {Array<GetAddonDto>}
   * @memberof GetTransactionDto
   */
  addon?: Array<GetAddonDto>;
  /**
   *
   * @type {number}
   * @memberof GetTransactionDto
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof GetTransactionDto
   */
  addon_duration?: number;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  remarks?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetTransactionDto
   */
  is_paid?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  subscription?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetTransactionDto
   */
  is_subscription?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  parent_code?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  parent_first_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  parent_last_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionDto
   */
  avatar?: string;
}
/**
 *
 * @export
 * @interface GetTransactionServiceDto
 */
export interface GetTransactionServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof GetTransactionServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  member: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionServiceDto
   */
  service: string;
  /**
   *
   * @type {number}
   * @memberof GetTransactionServiceDto
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface GetTransactionWaiverDto
 */
export interface GetTransactionWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof GetTransactionWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  signature?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  waiver?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  subscription?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  sub_title?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  font_size?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  batch: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetTransactionWaiverDto
   */
  business_name?: string;
}
/**
 *
 * @export
 * @interface GetWaiverDto
 */
export interface GetWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof GetWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof GetWaiverDto
   */
  font_size: number;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  sub_title?: string;
}
/**
 *
 * @export
 * @interface MemberControllerAll200Response
 */
export interface MemberControllerAll200Response {
  /**
   *
   * @type {number}
   * @memberof MemberControllerAll200Response
   */
  count?: number;
  /**
   *
   * @type {Array<AllMemberDto>}
   * @memberof MemberControllerAll200Response
   */
  data?: Array<AllMemberDto>;
}
/**
 *
 * @export
 * @interface MemberControllerGet200Response
 */
export interface MemberControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof MemberControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetMemberDto>}
   * @memberof MemberControllerGet200Response
   */
  data?: Array<GetMemberDto>;
}
/**
 *
 * @export
 * @interface MemberControllerGetChildren200Response
 */
export interface MemberControllerGetChildren200Response {
  /**
   *
   * @type {number}
   * @memberof MemberControllerGetChildren200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetMemberChildDto>}
   * @memberof MemberControllerGetChildren200Response
   */
  data?: Array<GetMemberChildDto>;
}
/**
 *
 * @export
 * @interface MessageArrayDataResponseDto
 */
export interface MessageArrayDataResponseDto {
  /**
   *
   * @type {string}
   * @memberof MessageArrayDataResponseDto
   */
  message: string;
  /**
   *
   * @type {Array<MessageWithIdentifierDto>}
   * @memberof MessageArrayDataResponseDto
   */
  data: Array<MessageWithIdentifierDto>;
}
/**
 *
 * @export
 * @interface MessageResponseDto
 */
export interface MessageResponseDto {
  /**
   *
   * @type {string}
   * @memberof MessageResponseDto
   */
  message?: string;
  /**
   *
   * @type {object}
   * @memberof MessageResponseDto
   */
  data?: object;
}
/**
 *
 * @export
 * @interface MessageWithIdentifierDto
 */
export interface MessageWithIdentifierDto {
  /**
   *
   * @type {string}
   * @memberof MessageWithIdentifierDto
   */
  identifier: string;
  /**
   *
   * @type {string}
   * @memberof MessageWithIdentifierDto
   */
  message: string;
}
/**
 *
 * @export
 * @interface MiniTransactionDto
 */
export interface MiniTransactionDto {
  /**
   *
   * @type {string}
   * @memberof MiniTransactionDto
   */
  code: string;
  /**
   *
   * @type {Array<GetServiceV2Dto>}
   * @memberof MiniTransactionDto
   */
  service?: Array<GetServiceV2Dto>;
}
/**
 *
 * @export
 * @interface PaymentControllerBilling200Response
 */
export interface PaymentControllerBilling200Response {
  /**
   *
   * @type {number}
   * @memberof PaymentControllerBilling200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetBillingDto>}
   * @memberof PaymentControllerBilling200Response
   */
  data?: Array<GetBillingDto>;
}
/**
 *
 * @export
 * @interface PaymentControllerGet200Response
 */
export interface PaymentControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof PaymentControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetPaymentDto>}
   * @memberof PaymentControllerGet200Response
   */
  data?: Array<GetPaymentDto>;
}
/**
 *
 * @export
 * @interface PersonAddressControllerGet200Response
 */
export interface PersonAddressControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof PersonAddressControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetPersonAddressDto>}
   * @memberof PersonAddressControllerGet200Response
   */
  data?: Array<GetPersonAddressDto>;
}
/**
 *
 * @export
 * @interface PersonControllerGet200Response
 */
export interface PersonControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof PersonControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetPersonDto>}
   * @memberof PersonControllerGet200Response
   */
  data?: Array<GetPersonDto>;
}
/**
 *
 * @export
 * @interface RenewRefreshTokenDto
 */
export interface RenewRefreshTokenDto {
  /**
   *
   * @type {string}
   * @memberof RenewRefreshTokenDto
   */
  user_code?: string;
  /**
   *
   * @type {string}
   * @memberof RenewRefreshTokenDto
   */
  refresh_token?: string;
  /**
   *
   * @type {number}
   * @memberof RenewRefreshTokenDto
   */
  refresh_exp?: number;
}
/**
 *
 * @export
 * @interface RewardControllerGet200Response
 */
export interface RewardControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof RewardControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetRewardDto>}
   * @memberof RewardControllerGet200Response
   */
  data?: Array<GetRewardDto>;
}
/**
 *
 * @export
 * @interface SigninUserRequestDto
 */
export interface SigninUserRequestDto {
  /**
   *
   * @type {string}
   * @memberof SigninUserRequestDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof SigninUserRequestDto
   */
  password: string;
}
/**
 *
 * @export
 * @interface SubscriptionControllerGet200Response
 */
export interface SubscriptionControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof SubscriptionControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetSubscriptionDto>}
   * @memberof SubscriptionControllerGet200Response
   */
  data?: Array<GetSubscriptionDto>;
}
/**
 *
 * @export
 * @interface SwaggerExceptionResponseDto
 */
export interface SwaggerExceptionResponseDto {
  /**
   *
   * @type {string}
   * @memberof SwaggerExceptionResponseDto
   */
  message: string;
}
/**
 *
 * @export
 * @interface TenantControllerGet200Response
 */
export interface TenantControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof TenantControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetTenantDto>}
   * @memberof TenantControllerGet200Response
   */
  data?: Array<GetTenantDto>;
}
/**
 *
 * @export
 * @interface TokenDto
 */
export interface TokenDto {
  /**
   *
   * @type {string}
   * @memberof TokenDto
   */
  access_token?: string;
  /**
   *
   * @type {string}
   * @memberof TokenDto
   */
  refresh_token?: string;
  /**
   *
   * @type {string}
   * @memberof TokenDto
   */
  user_code?: string;
  /**
   *
   * @type {number}
   * @memberof TokenDto
   */
  access_exp?: number;
  /**
   *
   * @type {number}
   * @memberof TokenDto
   */
  refresh_exp?: number;
}
/**
 *
 * @export
 * @interface TransactionAddonControllerGet200Response
 */
export interface TransactionAddonControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof TransactionAddonControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetTransactionAddonDto>}
   * @memberof TransactionAddonControllerGet200Response
   */
  data?: Array<GetTransactionAddonDto>;
}
/**
 *
 * @export
 * @interface TransactionControllerDashboard200Response
 */
export interface TransactionControllerDashboard200Response {
  /**
   *
   * @type {string}
   * @memberof TransactionControllerDashboard200Response
   */
  message?: string;
  /**
   *
   * @type {DashboardDto}
   * @memberof TransactionControllerDashboard200Response
   */
  data?: DashboardDto;
}
/**
 *
 * @export
 * @interface TransactionControllerGet200Response
 */
export interface TransactionControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof TransactionControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetTransactionDto>}
   * @memberof TransactionControllerGet200Response
   */
  data?: Array<GetTransactionDto>;
}
/**
 *
 * @export
 * @interface TransactionServiceControllerGet200Response
 */
export interface TransactionServiceControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof TransactionServiceControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetTransactionServiceDto>}
   * @memberof TransactionServiceControllerGet200Response
   */
  data?: Array<GetTransactionServiceDto>;
}
/**
 *
 * @export
 * @interface TransactionWaiverControllerGet200Response
 */
export interface TransactionWaiverControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof TransactionWaiverControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetTransactionWaiverDto>}
   * @memberof TransactionWaiverControllerGet200Response
   */
  data?: Array<GetTransactionWaiverDto>;
}
/**
 *
 * @export
 * @interface UtilAttachmentTypeControllerGet200Response
 */
export interface UtilAttachmentTypeControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilAttachmentTypeControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetAttachmentTypeDto>}
   * @memberof UtilAttachmentTypeControllerGet200Response
   */
  data?: Array<GetAttachmentTypeDto>;
}
/**
 *
 * @export
 * @interface UtilBranchControllerGet200Response
 */
export interface UtilBranchControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilBranchControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetBranchDto>}
   * @memberof UtilBranchControllerGet200Response
   */
  data?: Array<GetBranchDto>;
}
/**
 *
 * @export
 * @interface UtilConfigControllerGet200Response
 */
export interface UtilConfigControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilConfigControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetConfigDto>}
   * @memberof UtilConfigControllerGet200Response
   */
  data?: Array<GetConfigDto>;
}
/**
 *
 * @export
 * @interface UtilItemControllerGet200Response
 */
export interface UtilItemControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilItemControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetItemDto>}
   * @memberof UtilItemControllerGet200Response
   */
  data?: Array<GetItemDto>;
}
/**
 *
 * @export
 * @interface UtilRequestTypeControllerGet200Response
 */
export interface UtilRequestTypeControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilRequestTypeControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetRequestTypeDto>}
   * @memberof UtilRequestTypeControllerGet200Response
   */
  data?: Array<GetRequestTypeDto>;
}
/**
 *
 * @export
 * @interface UtilRoleControllerGet200Response
 */
export interface UtilRoleControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilRoleControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetRoleDto>}
   * @memberof UtilRoleControllerGet200Response
   */
  data?: Array<GetRoleDto>;
}
/**
 *
 * @export
 * @interface UtilServiceControllerGet200Response
 */
export interface UtilServiceControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilServiceControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetServiceDto>}
   * @memberof UtilServiceControllerGet200Response
   */
  data?: Array<GetServiceDto>;
}
/**
 *
 * @export
 * @interface UtilStatusControllerGet200Response
 */
export interface UtilStatusControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilStatusControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetStatusDto>}
   * @memberof UtilStatusControllerGet200Response
   */
  data?: Array<GetStatusDto>;
}
/**
 *
 * @export
 * @interface WaiverControllerGet200Response
 */
export interface WaiverControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof WaiverControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetWaiverDto>}
   * @memberof WaiverControllerGet200Response
   */
  data?: Array<GetWaiverDto>;
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {SigninUserRequestDto} signinUserRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerAuthenticate: async (
      signinUserRequestDto: SigninUserRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'signinUserRequestDto' is not null or undefined
      assertParamExists(
        "authenticationControllerAuthenticate",
        "signinUserRequestDto",
        signinUserRequestDto
      );
      const localVarPath = `/api/v1/authentication/signin`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        signinUserRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerIntrospect: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/authentication/instrospect`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefresh: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/authentication/refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefreshRenew: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/authentication/refresh/renew`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SigninUserRequestDto} signinUserRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerAuthenticate(
      signinUserRequestDto: SigninUserRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthenticationControllerAuthenticate201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerAuthenticate(
          signinUserRequestDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerAuthenticate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerIntrospect(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerIntrospect(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerIntrospect"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerRefresh(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthenticationControllerAuthenticate201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerRefresh(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerRefresh"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerRefreshRenew(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthenticationControllerRefreshRenew201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerRefreshRenew(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerRefreshRenew"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthenticationApiFp(configuration);
  return {
    /**
     *
     * @param {SigninUserRequestDto} signinUserRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerAuthenticate(
      signinUserRequestDto: SigninUserRequestDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AuthenticationControllerAuthenticate201Response> {
      return localVarFp
        .authenticationControllerAuthenticate(signinUserRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerIntrospect(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .authenticationControllerIntrospect(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefresh(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AuthenticationControllerAuthenticate201Response> {
      return localVarFp
        .authenticationControllerRefresh(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefreshRenew(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AuthenticationControllerRefreshRenew201Response> {
      return localVarFp
        .authenticationControllerRefreshRenew(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
  /**
   *
   * @param {SigninUserRequestDto} signinUserRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerAuthenticate(
    signinUserRequestDto: SigninUserRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerAuthenticate(signinUserRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerIntrospect(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerIntrospect(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerRefresh(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerRefresh(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerRefreshRenew(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerRefreshRenew(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DeviceAuthorizationApi - axios parameter creator
 * @export
 */
export const DeviceAuthorizationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {DeviceAuthorization} deviceAuthorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deviceRegistrationControllerRegister: async (
      deviceAuthorization: DeviceAuthorization,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceAuthorization' is not null or undefined
      assertParamExists(
        "deviceRegistrationControllerRegister",
        "deviceAuthorization",
        deviceAuthorization
      );
      const localVarPath = `/device/authorization/register`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deviceAuthorization,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DeviceAuthorizationApi - functional programming interface
 * @export
 */
export const DeviceAuthorizationApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    DeviceAuthorizationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {DeviceAuthorization} deviceAuthorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deviceRegistrationControllerRegister(
      deviceAuthorization: DeviceAuthorization,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DeviceRegistrationControllerRegister201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deviceRegistrationControllerRegister(
          deviceAuthorization,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DeviceAuthorizationApi.deviceRegistrationControllerRegister"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DeviceAuthorizationApi - factory interface
 * @export
 */
export const DeviceAuthorizationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DeviceAuthorizationApiFp(configuration);
  return {
    /**
     *
     * @param {DeviceAuthorization} deviceAuthorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deviceRegistrationControllerRegister(
      deviceAuthorization: DeviceAuthorization,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DeviceRegistrationControllerRegister201Response> {
      return localVarFp
        .deviceRegistrationControllerRegister(deviceAuthorization, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DeviceAuthorizationApi - object-oriented interface
 * @export
 * @class DeviceAuthorizationApi
 * @extends {BaseAPI}
 */
export class DeviceAuthorizationApi extends BaseAPI {
  /**
   *
   * @param {DeviceAuthorization} deviceAuthorization
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeviceAuthorizationApi
   */
  public deviceRegistrationControllerRegister(
    deviceAuthorization: DeviceAuthorization,
    options?: RawAxiosRequestConfig
  ) {
    return DeviceAuthorizationApiFp(this.configuration)
      .deviceRegistrationControllerRegister(deviceAuthorization, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * GoogleCloudStorageApi - axios parameter creator
 * @export
 */
export const GoogleCloudStorageApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} filepath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetImage: async (
      filepath: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filepath' is not null or undefined
      assertParamExists("cloudStorageControllerGetImage", "filepath", filepath);
      const localVarPath = `/api/v1/cloud/storage/asset/{filepath}`.replace(
        `{${"filepath"}}`,
        encodeURIComponent(String(filepath))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetSampleAssets: async (
      params: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'params' is not null or undefined
      assertParamExists(
        "cloudStorageControllerGetSampleAssets",
        "params",
        params
      );
      const localVarPath = `/api/v1/cloud/storage/sample/{params}`.replace(
        `{${"params"}}`,
        encodeURIComponent(String(params))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerUploadMedia: async (
      file: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists("cloudStorageControllerUploadMedia", "file", file);
      const localVarPath = `/api/v1/cloud/storage/upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GoogleCloudStorageApi - functional programming interface
 * @export
 */
export const GoogleCloudStorageApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    GoogleCloudStorageApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} filepath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cloudStorageControllerGetImage(
      filepath: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cloudStorageControllerGetImage(
          filepath,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "GoogleCloudStorageApi.cloudStorageControllerGetImage"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cloudStorageControllerGetSampleAssets(
      params: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cloudStorageControllerGetSampleAssets(
          params,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "GoogleCloudStorageApi.cloudStorageControllerGetSampleAssets"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cloudStorageControllerUploadMedia(
      file: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cloudStorageControllerUploadMedia(
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "GoogleCloudStorageApi.cloudStorageControllerUploadMedia"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * GoogleCloudStorageApi - factory interface
 * @export
 */
export const GoogleCloudStorageApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = GoogleCloudStorageApiFp(configuration);
  return {
    /**
     *
     * @param {string} filepath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetImage(
      filepath: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<File> {
      return localVarFp
        .cloudStorageControllerGetImage(filepath, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetSampleAssets(
      params: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cloudStorageControllerGetSampleAssets(params, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerUploadMedia(
      file: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cloudStorageControllerUploadMedia(file, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * GoogleCloudStorageApi - object-oriented interface
 * @export
 * @class GoogleCloudStorageApi
 * @extends {BaseAPI}
 */
export class GoogleCloudStorageApi extends BaseAPI {
  /**
   *
   * @param {string} filepath
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GoogleCloudStorageApi
   */
  public cloudStorageControllerGetImage(
    filepath: string,
    options?: RawAxiosRequestConfig
  ) {
    return GoogleCloudStorageApiFp(this.configuration)
      .cloudStorageControllerGetImage(filepath, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} params
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GoogleCloudStorageApi
   */
  public cloudStorageControllerGetSampleAssets(
    params: string,
    options?: RawAxiosRequestConfig
  ) {
    return GoogleCloudStorageApiFp(this.configuration)
      .cloudStorageControllerGetSampleAssets(params, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GoogleCloudStorageApi
   */
  public cloudStorageControllerUploadMedia(
    file: File,
    options?: RawAxiosRequestConfig
  ) {
    return GoogleCloudStorageApiFp(this.configuration)
      .cloudStorageControllerUploadMedia(file, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MemberApi - axios parameter creator
 * @export
 */
export const MemberApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerAll: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/member/all`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateMemberDto} member
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerCreate: async (
      member: CreateMemberDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'member' is not null or undefined
      assertParamExists("memberControllerCreate", "member", member);
      const localVarPath = `/api/v1/member/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (member !== undefined) {
        localVarFormParams.append("member", JSON.stringify(member));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteMemberDto} deleteMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerDelete: async (
      deleteMemberDto: DeleteMemberDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteMemberDto' is not null or undefined
      assertParamExists(
        "memberControllerDelete",
        "deleteMemberDto",
        deleteMemberDto
      );
      const localVarPath = `/api/v1/member/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteMemberDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditMemberDto} member
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerEdit: async (
      member: EditMemberDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'member' is not null or undefined
      assertParamExists("memberControllerEdit", "member", member);
      const localVarPath = `/api/v1/member/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (member !== undefined) {
        localVarFormParams.append("member", JSON.stringify(member));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/member/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerGetChildren: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/member/children`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerGetParent: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/member/parent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MemberApi - functional programming interface
 * @export
 */
export const MemberApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MemberApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberControllerAll(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MemberControllerAll200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberControllerAll(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberControllerAll"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateMemberDto} member
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberControllerCreate(
      member: CreateMemberDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberControllerCreate(
          member,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteMemberDto} deleteMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberControllerDelete(
      deleteMemberDto: DeleteMemberDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberControllerDelete(
          deleteMemberDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditMemberDto} member
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberControllerEdit(
      member: EditMemberDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberControllerEdit(
          member,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MemberControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberControllerGetChildren(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MemberControllerGetChildren200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberControllerGetChildren(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberControllerGetChildren"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberControllerGetParent(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MemberControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberControllerGetParent(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberControllerGetParent"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MemberApi - factory interface
 * @export
 */
export const MemberApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MemberApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerAll(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberControllerAll200Response> {
      return localVarFp
        .memberControllerAll(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateMemberDto} member
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerCreate(
      member: CreateMemberDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .memberControllerCreate(member, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteMemberDto} deleteMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerDelete(
      deleteMemberDto: DeleteMemberDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .memberControllerDelete(deleteMemberDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditMemberDto} member
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerEdit(
      member: EditMemberDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .memberControllerEdit(member, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberControllerGet200Response> {
      return localVarFp
        .memberControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerGetChildren(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberControllerGetChildren200Response> {
      return localVarFp
        .memberControllerGetChildren(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberControllerGetParent(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberControllerGet200Response> {
      return localVarFp
        .memberControllerGetParent(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MemberApi - object-oriented interface
 * @export
 * @class MemberApi
 * @extends {BaseAPI}
 */
export class MemberApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public memberControllerAll(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .memberControllerAll(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateMemberDto} member
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public memberControllerCreate(
    member: CreateMemberDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .memberControllerCreate(member, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteMemberDto} deleteMemberDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public memberControllerDelete(
    deleteMemberDto: DeleteMemberDto,
    options?: RawAxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .memberControllerDelete(deleteMemberDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditMemberDto} member
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public memberControllerEdit(
    member: EditMemberDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .memberControllerEdit(member, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public memberControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .memberControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public memberControllerGetChildren(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .memberControllerGetChildren(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApi
   */
  public memberControllerGetParent(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemberApiFp(this.configuration)
      .memberControllerGetParent(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerAttachFile: async (
      code: string,
      attachmentType: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("paymentControllerAttachFile", "code", code);
      // verify required parameter 'attachmentType' is not null or undefined
      assertParamExists(
        "paymentControllerAttachFile",
        "attachmentType",
        attachmentType
      );
      const localVarPath = `/api/v1/payment/attach-file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (code !== undefined) {
        localVarFormParams.append("code", code as any);
      }

      if (attachmentType !== undefined) {
        localVarFormParams.append("attachment_type", attachmentType as any);
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerBilling: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/payment/billing`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerCancel: async (
      deletePaymentDto: DeletePaymentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePaymentDto' is not null or undefined
      assertParamExists(
        "paymentControllerCancel",
        "deletePaymentDto",
        deletePaymentDto
      );
      const localVarPath = `/api/v1/payment/cancel`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePaymentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePaymentDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerCreate: async (
      payment: CreatePaymentDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'payment' is not null or undefined
      assertParamExists("paymentControllerCreate", "payment", payment);
      const localVarPath = `/api/v1/payment/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (payment !== undefined) {
        localVarFormParams.append("payment", JSON.stringify(payment));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerDelete: async (
      deletePaymentDto: DeletePaymentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePaymentDto' is not null or undefined
      assertParamExists(
        "paymentControllerDelete",
        "deletePaymentDto",
        deletePaymentDto
      );
      const localVarPath = `/api/v1/payment/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePaymentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditPaymentDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerEdit: async (
      payment: EditPaymentDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'payment' is not null or undefined
      assertParamExists("paymentControllerEdit", "payment", payment);
      const localVarPath = `/api/v1/payment/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (payment !== undefined) {
        localVarFormParams.append("payment", JSON.stringify(payment));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/payment/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerReject: async (
      deletePaymentDto: DeletePaymentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePaymentDto' is not null or undefined
      assertParamExists(
        "paymentControllerReject",
        "deletePaymentDto",
        deletePaymentDto
      );
      const localVarPath = `/api/v1/payment/reject`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePaymentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerVerify: async (
      deletePaymentDto: DeletePaymentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePaymentDto' is not null or undefined
      assertParamExists(
        "paymentControllerVerify",
        "deletePaymentDto",
        deletePaymentDto
      );
      const localVarPath = `/api/v1/payment/verify`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePaymentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerAttachFile(
          code,
          attachmentType,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerAttachFile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerBilling(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaymentControllerBilling200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerBilling(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerBilling"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerCancel(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerCancel(
          deletePaymentDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerCancel"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePaymentDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerCreate(
      payment: CreatePaymentDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerCreate(
          payment,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerDelete(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerDelete(
          deletePaymentDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditPaymentDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerEdit(
      payment: EditPaymentDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerEdit(
          payment,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaymentControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerReject(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerReject(
          deletePaymentDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerReject"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerVerify(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerVerify(
          deletePaymentDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerVerify"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PaymentApiFp(configuration);
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerAttachFile(code, attachmentType, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerBilling(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaymentControllerBilling200Response> {
      return localVarFp
        .paymentControllerBilling(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerCancel(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerCancel(deletePaymentDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePaymentDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerCreate(
      payment: CreatePaymentDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerCreate(payment, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerDelete(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerDelete(deletePaymentDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditPaymentDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerEdit(
      payment: EditPaymentDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerEdit(payment, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaymentControllerGet200Response> {
      return localVarFp
        .paymentControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerReject(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerReject(deletePaymentDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerVerify(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerVerify(deletePaymentDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
  /**
   *
   * @param {string} code
   * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerAttachFile(
    code: string,
    attachmentType: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerAttachFile(code, attachmentType, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerBilling(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerBilling(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePaymentDto} deletePaymentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerCancel(
    deletePaymentDto: DeletePaymentDto,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerCancel(deletePaymentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePaymentDto} payment
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerCreate(
    payment: CreatePaymentDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerCreate(payment, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePaymentDto} deletePaymentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerDelete(
    deletePaymentDto: DeletePaymentDto,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerDelete(deletePaymentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditPaymentDto} payment
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerEdit(
    payment: EditPaymentDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerEdit(payment, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePaymentDto} deletePaymentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerReject(
    deletePaymentDto: DeletePaymentDto,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerReject(deletePaymentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePaymentDto} deletePaymentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerVerify(
    deletePaymentDto: DeletePaymentDto,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerVerify(deletePaymentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PersonApi - axios parameter creator
 * @export
 */
export const PersonApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerAttachFile: async (
      code: string,
      attachmentType: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("personControllerAttachFile", "code", code);
      // verify required parameter 'attachmentType' is not null or undefined
      assertParamExists(
        "personControllerAttachFile",
        "attachmentType",
        attachmentType
      );
      const localVarPath = `/api/v1/person/attach-file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (code !== undefined) {
        localVarFormParams.append("code", code as any);
      }

      if (attachmentType !== undefined) {
        localVarFormParams.append("attachment_type", attachmentType as any);
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BlockPersonDto} blockPersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerBlock: async (
      blockPersonDto: BlockPersonDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'blockPersonDto' is not null or undefined
      assertParamExists(
        "personControllerBlock",
        "blockPersonDto",
        blockPersonDto
      );
      const localVarPath = `/api/v1/person/block`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        blockPersonDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerCreate: async (
      person: CreatePersonExtendedDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'person' is not null or undefined
      assertParamExists("personControllerCreate", "person", person);
      const localVarPath = `/api/v1/person/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (person !== undefined) {
        localVarFormParams.append("person", JSON.stringify(person));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePersonDto} deletePersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerDelete: async (
      deletePersonDto: DeletePersonDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePersonDto' is not null or undefined
      assertParamExists(
        "personControllerDelete",
        "deletePersonDto",
        deletePersonDto
      );
      const localVarPath = `/api/v1/person/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePersonDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditPersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerEdit: async (
      person: EditPersonExtendedDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'person' is not null or undefined
      assertParamExists("personControllerEdit", "person", person);
      const localVarPath = `/api/v1/person/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (person !== undefined) {
        localVarFormParams.append("person", JSON.stringify(person));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/person/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PersonApi - functional programming interface
 * @export
 */
export const PersonApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PersonApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerAttachFile(
          code,
          attachmentType,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerAttachFile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {BlockPersonDto} blockPersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerBlock(
      blockPersonDto: BlockPersonDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerBlock(
          blockPersonDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerBlock"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerCreate(
      person: CreatePersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerCreate(
          person,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePersonDto} deletePersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerDelete(
      deletePersonDto: DeletePersonDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerDelete(
          deletePersonDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditPersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerEdit(
      person: EditPersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerEdit(
          person,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PersonApi - factory interface
 * @export
 */
export const PersonApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PersonApiFp(configuration);
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerAttachFile(code, attachmentType, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BlockPersonDto} blockPersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerBlock(
      blockPersonDto: BlockPersonDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerBlock(blockPersonDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerCreate(
      person: CreatePersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerCreate(person, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePersonDto} deletePersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerDelete(
      deletePersonDto: DeletePersonDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerDelete(deletePersonDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditPersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerEdit(
      person: EditPersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerEdit(person, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerGet200Response> {
      return localVarFp
        .personControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PersonApi - object-oriented interface
 * @export
 * @class PersonApi
 * @extends {BaseAPI}
 */
export class PersonApi extends BaseAPI {
  /**
   *
   * @param {string} code
   * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerAttachFile(
    code: string,
    attachmentType: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerAttachFile(code, attachmentType, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BlockPersonDto} blockPersonDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerBlock(
    blockPersonDto: BlockPersonDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerBlock(blockPersonDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePersonExtendedDto} person
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerCreate(
    person: CreatePersonExtendedDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerCreate(person, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePersonDto} deletePersonDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerDelete(
    deletePersonDto: DeletePersonDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerDelete(deletePersonDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditPersonExtendedDto} person
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerEdit(
    person: EditPersonExtendedDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerEdit(person, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PersonAddressApi - axios parameter creator
 * @export
 */
export const PersonAddressApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreatePersonAddressDto} createPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerCreate: async (
      createPersonAddressDto: CreatePersonAddressDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createPersonAddressDto' is not null or undefined
      assertParamExists(
        "personAddressControllerCreate",
        "createPersonAddressDto",
        createPersonAddressDto
      );
      const localVarPath = `/api/v1/person-address/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPersonAddressDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePersonAddressDto} deletePersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerDelete: async (
      deletePersonAddressDto: DeletePersonAddressDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePersonAddressDto' is not null or undefined
      assertParamExists(
        "personAddressControllerDelete",
        "deletePersonAddressDto",
        deletePersonAddressDto
      );
      const localVarPath = `/api/v1/person-address/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePersonAddressDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditPersonAddressDto} editPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerEdit: async (
      editPersonAddressDto: EditPersonAddressDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editPersonAddressDto' is not null or undefined
      assertParamExists(
        "personAddressControllerEdit",
        "editPersonAddressDto",
        editPersonAddressDto
      );
      const localVarPath = `/api/v1/person-address/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editPersonAddressDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/person-address/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PersonAddressApi - functional programming interface
 * @export
 */
export const PersonAddressApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    PersonAddressApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreatePersonAddressDto} createPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerCreate(
      createPersonAddressDto: CreatePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerCreate(
          createPersonAddressDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePersonAddressDto} deletePersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerDelete(
      deletePersonAddressDto: DeletePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerDelete(
          deletePersonAddressDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditPersonAddressDto} editPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerEdit(
      editPersonAddressDto: EditPersonAddressDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerEdit(
          editPersonAddressDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonAddressControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PersonAddressApi - factory interface
 * @export
 */
export const PersonAddressApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PersonAddressApiFp(configuration);
  return {
    /**
     *
     * @param {CreatePersonAddressDto} createPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerCreate(
      createPersonAddressDto: CreatePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personAddressControllerCreate(createPersonAddressDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePersonAddressDto} deletePersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerDelete(
      deletePersonAddressDto: DeletePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personAddressControllerDelete(deletePersonAddressDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditPersonAddressDto} editPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerEdit(
      editPersonAddressDto: EditPersonAddressDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personAddressControllerEdit(editPersonAddressDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonAddressControllerGet200Response> {
      return localVarFp
        .personAddressControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PersonAddressApi - object-oriented interface
 * @export
 * @class PersonAddressApi
 * @extends {BaseAPI}
 */
export class PersonAddressApi extends BaseAPI {
  /**
   *
   * @param {CreatePersonAddressDto} createPersonAddressDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerCreate(
    createPersonAddressDto: CreatePersonAddressDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerCreate(createPersonAddressDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePersonAddressDto} deletePersonAddressDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerDelete(
    deletePersonAddressDto: DeletePersonAddressDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerDelete(deletePersonAddressDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditPersonAddressDto} editPersonAddressDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerEdit(
    editPersonAddressDto: EditPersonAddressDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerEdit(editPersonAddressDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RewardApi - axios parameter creator
 * @export
 */
export const RewardApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateRewardDto} createRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerCreate: async (
      createRewardDto: CreateRewardDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createRewardDto' is not null or undefined
      assertParamExists(
        "rewardControllerCreate",
        "createRewardDto",
        createRewardDto
      );
      const localVarPath = `/api/v1/reward/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRewardDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteRewardDto} deleteRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerDelete: async (
      deleteRewardDto: DeleteRewardDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteRewardDto' is not null or undefined
      assertParamExists(
        "rewardControllerDelete",
        "deleteRewardDto",
        deleteRewardDto
      );
      const localVarPath = `/api/v1/reward/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRewardDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditRewardDto} editRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerEdit: async (
      editRewardDto: EditRewardDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editRewardDto' is not null or undefined
      assertParamExists("rewardControllerEdit", "editRewardDto", editRewardDto);
      const localVarPath = `/api/v1/reward/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editRewardDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/reward/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RewardApi - functional programming interface
 * @export
 */
export const RewardApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RewardApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateRewardDto} createRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rewardControllerCreate(
      createRewardDto: CreateRewardDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rewardControllerCreate(
          createRewardDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RewardApi.rewardControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteRewardDto} deleteRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rewardControllerDelete(
      deleteRewardDto: DeleteRewardDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rewardControllerDelete(
          deleteRewardDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RewardApi.rewardControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditRewardDto} editRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rewardControllerEdit(
      editRewardDto: EditRewardDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rewardControllerEdit(
          editRewardDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RewardApi.rewardControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rewardControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<RewardControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rewardControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RewardApi.rewardControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RewardApi - factory interface
 * @export
 */
export const RewardApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RewardApiFp(configuration);
  return {
    /**
     *
     * @param {CreateRewardDto} createRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerCreate(
      createRewardDto: CreateRewardDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .rewardControllerCreate(createRewardDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteRewardDto} deleteRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerDelete(
      deleteRewardDto: DeleteRewardDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .rewardControllerDelete(deleteRewardDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditRewardDto} editRewardDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerEdit(
      editRewardDto: EditRewardDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .rewardControllerEdit(editRewardDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewardControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RewardControllerGet200Response> {
      return localVarFp
        .rewardControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RewardApi - object-oriented interface
 * @export
 * @class RewardApi
 * @extends {BaseAPI}
 */
export class RewardApi extends BaseAPI {
  /**
   *
   * @param {CreateRewardDto} createRewardDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RewardApi
   */
  public rewardControllerCreate(
    createRewardDto: CreateRewardDto,
    options?: RawAxiosRequestConfig
  ) {
    return RewardApiFp(this.configuration)
      .rewardControllerCreate(createRewardDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteRewardDto} deleteRewardDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RewardApi
   */
  public rewardControllerDelete(
    deleteRewardDto: DeleteRewardDto,
    options?: RawAxiosRequestConfig
  ) {
    return RewardApiFp(this.configuration)
      .rewardControllerDelete(deleteRewardDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditRewardDto} editRewardDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RewardApi
   */
  public rewardControllerEdit(
    editRewardDto: EditRewardDto,
    options?: RawAxiosRequestConfig
  ) {
    return RewardApiFp(this.configuration)
      .rewardControllerEdit(editRewardDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RewardApi
   */
  public rewardControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return RewardApiFp(this.configuration)
      .rewardControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schedulerControllerNoClockout: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/scheduler/default`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SchedulerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async schedulerControllerNoClockout(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.schedulerControllerNoClockout(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SchedulerApi.schedulerControllerNoClockout"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SchedulerApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schedulerControllerNoClockout(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .schedulerControllerNoClockout(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SchedulerApi
   */
  public schedulerControllerNoClockout(options?: RawAxiosRequestConfig) {
    return SchedulerApiFp(this.configuration)
      .schedulerControllerNoClockout(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateSubscriptionDto} createSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerCreate: async (
      createSubscriptionDto: CreateSubscriptionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createSubscriptionDto' is not null or undefined
      assertParamExists(
        "subscriptionControllerCreate",
        "createSubscriptionDto",
        createSubscriptionDto
      );
      const localVarPath = `/api/v1/subscription/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createSubscriptionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteSubscriptionDto} deleteSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerDelete: async (
      deleteSubscriptionDto: DeleteSubscriptionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteSubscriptionDto' is not null or undefined
      assertParamExists(
        "subscriptionControllerDelete",
        "deleteSubscriptionDto",
        deleteSubscriptionDto
      );
      const localVarPath = `/api/v1/subscription/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteSubscriptionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditSubscriptionDto} editSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerEdit: async (
      editSubscriptionDto: EditSubscriptionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editSubscriptionDto' is not null or undefined
      assertParamExists(
        "subscriptionControllerEdit",
        "editSubscriptionDto",
        editSubscriptionDto
      );
      const localVarPath = `/api/v1/subscription/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editSubscriptionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/subscription/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SubscriptionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateSubscriptionDto} createSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscriptionControllerCreate(
      createSubscriptionDto: CreateSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.subscriptionControllerCreate(
          createSubscriptionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SubscriptionApi.subscriptionControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteSubscriptionDto} deleteSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscriptionControllerDelete(
      deleteSubscriptionDto: DeleteSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.subscriptionControllerDelete(
          deleteSubscriptionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SubscriptionApi.subscriptionControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditSubscriptionDto} editSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscriptionControllerEdit(
      editSubscriptionDto: EditSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.subscriptionControllerEdit(
          editSubscriptionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SubscriptionApi.subscriptionControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscriptionControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SubscriptionControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.subscriptionControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SubscriptionApi.subscriptionControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SubscriptionApiFp(configuration);
  return {
    /**
     *
     * @param {CreateSubscriptionDto} createSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerCreate(
      createSubscriptionDto: CreateSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .subscriptionControllerCreate(createSubscriptionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteSubscriptionDto} deleteSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerDelete(
      deleteSubscriptionDto: DeleteSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .subscriptionControllerDelete(deleteSubscriptionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditSubscriptionDto} editSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerEdit(
      editSubscriptionDto: EditSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .subscriptionControllerEdit(editSubscriptionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SubscriptionControllerGet200Response> {
      return localVarFp
        .subscriptionControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
  /**
   *
   * @param {CreateSubscriptionDto} createSubscriptionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public subscriptionControllerCreate(
    createSubscriptionDto: CreateSubscriptionDto,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionApiFp(this.configuration)
      .subscriptionControllerCreate(createSubscriptionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteSubscriptionDto} deleteSubscriptionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public subscriptionControllerDelete(
    deleteSubscriptionDto: DeleteSubscriptionDto,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionApiFp(this.configuration)
      .subscriptionControllerDelete(deleteSubscriptionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditSubscriptionDto} editSubscriptionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public subscriptionControllerEdit(
    editSubscriptionDto: EditSubscriptionDto,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionApiFp(this.configuration)
      .subscriptionControllerEdit(editSubscriptionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public subscriptionControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionApiFp(this.configuration)
      .subscriptionControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerAttachFile: async (
      code: string,
      attachmentType: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("tenantControllerAttachFile", "code", code);
      // verify required parameter 'attachmentType' is not null or undefined
      assertParamExists(
        "tenantControllerAttachFile",
        "attachmentType",
        attachmentType
      );
      const localVarPath = `/api/v1/tenant/attach-file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (code !== undefined) {
        localVarFormParams.append("code", code as any);
      }

      if (attachmentType !== undefined) {
        localVarFormParams.append("attachment_type", attachmentType as any);
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateTenantDto} tenant
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerCreate: async (
      tenant: CreateTenantDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("tenantControllerCreate", "tenant", tenant);
      const localVarPath = `/api/v1/tenant/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (tenant !== undefined) {
        localVarFormParams.append("tenant", JSON.stringify(tenant));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTenantDto} deleteTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerDelete: async (
      deleteTenantDto: DeleteTenantDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTenantDto' is not null or undefined
      assertParamExists(
        "tenantControllerDelete",
        "deleteTenantDto",
        deleteTenantDto
      );
      const localVarPath = `/api/v1/tenant/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTenantDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditTenantDto} tenant
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerEdit: async (
      tenant: EditTenantDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists("tenantControllerEdit", "tenant", tenant);
      const localVarPath = `/api/v1/tenant/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (tenant !== undefined) {
        localVarFormParams.append("tenant", JSON.stringify(tenant));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tenant/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerAttachFile(
          code,
          attachmentType,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerAttachFile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateTenantDto} tenant
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerCreate(
      tenant: CreateTenantDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerCreate(
          tenant,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTenantDto} deleteTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerDelete(
      deleteTenantDto: DeleteTenantDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerDelete(
          deleteTenantDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditTenantDto} tenant
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerEdit(
      tenant: EditTenantDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerEdit(
          tenant,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TenantControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TenantApiFp(configuration);
  return {
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerAttachFile(code, attachmentType, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateTenantDto} tenant
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerCreate(
      tenant: CreateTenantDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerCreate(tenant, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTenantDto} deleteTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerDelete(
      deleteTenantDto: DeleteTenantDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerDelete(deleteTenantDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditTenantDto} tenant
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerEdit(
      tenant: EditTenantDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerEdit(tenant, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TenantControllerGet200Response> {
      return localVarFp
        .tenantControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
  /**
   *
   * @param {string} code
   * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerAttachFile(
    code: string,
    attachmentType: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerAttachFile(code, attachmentType, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateTenantDto} tenant
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerCreate(
    tenant: CreateTenantDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerCreate(tenant, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTenantDto} deleteTenantDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerDelete(
    deleteTenantDto: DeleteTenantDto,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerDelete(deleteTenantDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditTenantDto} tenant
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerEdit(
    tenant: EditTenantDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerEdit(tenant, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerCancel: async (
      deleteTransactionDto: DeleteTransactionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionDto' is not null or undefined
      assertParamExists(
        "transactionControllerCancel",
        "deleteTransactionDto",
        deleteTransactionDto
      );
      const localVarPath = `/api/v1/transaction/cancel`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerComplete: async (
      deleteTransactionDto: DeleteTransactionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionDto' is not null or undefined
      assertParamExists(
        "transactionControllerComplete",
        "deleteTransactionDto",
        deleteTransactionDto
      );
      const localVarPath = `/api/v1/transaction/complete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddTransactionDto} addTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerCreate: async (
      addTransactionDto: AddTransactionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'addTransactionDto' is not null or undefined
      assertParamExists(
        "transactionControllerCreate",
        "addTransactionDto",
        addTransactionDto
      );
      const localVarPath = `/api/v1/transaction/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addTransactionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerDashboard: async (
      search?: string,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/transaction/dashboard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerDelete: async (
      deleteTransactionDto: DeleteTransactionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionDto' is not null or undefined
      assertParamExists(
        "transactionControllerDelete",
        "deleteTransactionDto",
        deleteTransactionDto
      );
      const localVarPath = `/api/v1/transaction/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditTransactionDto} editTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerEdit: async (
      editTransactionDto: EditTransactionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editTransactionDto' is not null or undefined
      assertParamExists(
        "transactionControllerEdit",
        "editTransactionDto",
        editTransactionDto
      );
      const localVarPath = `/api/v1/transaction/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editTransactionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/transaction/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerPaid: async (
      deleteTransactionDto: DeleteTransactionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionDto' is not null or undefined
      assertParamExists(
        "transactionControllerPaid",
        "deleteTransactionDto",
        deleteTransactionDto
      );
      const localVarPath = `/api/v1/transaction/paid`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TransactionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerCancel(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerCancel(
          deleteTransactionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerCancel"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerComplete(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerComplete(
          deleteTransactionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerComplete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AddTransactionDto} addTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerCreate(
      addTransactionDto: AddTransactionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerCreate(
          addTransactionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerDashboard(
      search?: string,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TransactionControllerDashboard200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerDashboard(
          search,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerDashboard"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerDelete(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerDelete(
          deleteTransactionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditTransactionDto} editTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerEdit(
      editTransactionDto: EditTransactionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerEdit(
          editTransactionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TransactionControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionControllerPaid(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionControllerPaid(
          deleteTransactionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TransactionApi.transactionControllerPaid"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionApiFp(configuration);
  return {
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerCancel(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionControllerCancel(deleteTransactionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerComplete(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionControllerComplete(deleteTransactionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddTransactionDto} addTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerCreate(
      addTransactionDto: AddTransactionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionControllerCreate(addTransactionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerDashboard(
      search?: string,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TransactionControllerDashboard200Response> {
      return localVarFp
        .transactionControllerDashboard(
          search,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerDelete(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionControllerDelete(deleteTransactionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditTransactionDto} editTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerEdit(
      editTransactionDto: EditTransactionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionControllerEdit(editTransactionDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TransactionControllerGet200Response> {
      return localVarFp
        .transactionControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTransactionDto} deleteTransactionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionControllerPaid(
      deleteTransactionDto: DeleteTransactionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionControllerPaid(deleteTransactionDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI {
  /**
   *
   * @param {DeleteTransactionDto} deleteTransactionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerCancel(
    deleteTransactionDto: DeleteTransactionDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerCancel(deleteTransactionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTransactionDto} deleteTransactionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerComplete(
    deleteTransactionDto: DeleteTransactionDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerComplete(deleteTransactionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddTransactionDto} addTransactionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerCreate(
    addTransactionDto: AddTransactionDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerCreate(addTransactionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerDashboard(
    search?: string,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerDashboard(
        search,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTransactionDto} deleteTransactionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerDelete(
    deleteTransactionDto: DeleteTransactionDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerDelete(deleteTransactionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditTransactionDto} editTransactionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerEdit(
    editTransactionDto: EditTransactionDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerEdit(editTransactionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTransactionDto} deleteTransactionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public transactionControllerPaid(
    deleteTransactionDto: DeleteTransactionDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .transactionControllerPaid(deleteTransactionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionAddonApi - axios parameter creator
 * @export
 */
export const TransactionAddonApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateTransactionAddonDto} createTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerCreate: async (
      createTransactionAddonDto: CreateTransactionAddonDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createTransactionAddonDto' is not null or undefined
      assertParamExists(
        "transactionAddonControllerCreate",
        "createTransactionAddonDto",
        createTransactionAddonDto
      );
      const localVarPath = `/api/v1/transaction-addon/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTransactionAddonDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTransactionAddonDto} deleteTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerDelete: async (
      deleteTransactionAddonDto: DeleteTransactionAddonDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionAddonDto' is not null or undefined
      assertParamExists(
        "transactionAddonControllerDelete",
        "deleteTransactionAddonDto",
        deleteTransactionAddonDto
      );
      const localVarPath = `/api/v1/transaction-addon/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionAddonDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditTransactionAddonDto} editTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerEdit: async (
      editTransactionAddonDto: EditTransactionAddonDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editTransactionAddonDto' is not null or undefined
      assertParamExists(
        "transactionAddonControllerEdit",
        "editTransactionAddonDto",
        editTransactionAddonDto
      );
      const localVarPath = `/api/v1/transaction-addon/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editTransactionAddonDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/transaction-addon/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionAddonApi - functional programming interface
 * @export
 */
export const TransactionAddonApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TransactionAddonApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateTransactionAddonDto} createTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionAddonControllerCreate(
      createTransactionAddonDto: CreateTransactionAddonDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionAddonControllerCreate(
          createTransactionAddonDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionAddonApi.transactionAddonControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTransactionAddonDto} deleteTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionAddonControllerDelete(
      deleteTransactionAddonDto: DeleteTransactionAddonDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionAddonControllerDelete(
          deleteTransactionAddonDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionAddonApi.transactionAddonControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditTransactionAddonDto} editTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionAddonControllerEdit(
      editTransactionAddonDto: EditTransactionAddonDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionAddonControllerEdit(
          editTransactionAddonDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionAddonApi.transactionAddonControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionAddonControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TransactionAddonControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionAddonControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionAddonApi.transactionAddonControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TransactionAddonApi - factory interface
 * @export
 */
export const TransactionAddonApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionAddonApiFp(configuration);
  return {
    /**
     *
     * @param {CreateTransactionAddonDto} createTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerCreate(
      createTransactionAddonDto: CreateTransactionAddonDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionAddonControllerCreate(createTransactionAddonDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTransactionAddonDto} deleteTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerDelete(
      deleteTransactionAddonDto: DeleteTransactionAddonDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionAddonControllerDelete(deleteTransactionAddonDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditTransactionAddonDto} editTransactionAddonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerEdit(
      editTransactionAddonDto: EditTransactionAddonDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionAddonControllerEdit(editTransactionAddonDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionAddonControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TransactionAddonControllerGet200Response> {
      return localVarFp
        .transactionAddonControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionAddonApi - object-oriented interface
 * @export
 * @class TransactionAddonApi
 * @extends {BaseAPI}
 */
export class TransactionAddonApi extends BaseAPI {
  /**
   *
   * @param {CreateTransactionAddonDto} createTransactionAddonDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionAddonApi
   */
  public transactionAddonControllerCreate(
    createTransactionAddonDto: CreateTransactionAddonDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionAddonApiFp(this.configuration)
      .transactionAddonControllerCreate(createTransactionAddonDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTransactionAddonDto} deleteTransactionAddonDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionAddonApi
   */
  public transactionAddonControllerDelete(
    deleteTransactionAddonDto: DeleteTransactionAddonDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionAddonApiFp(this.configuration)
      .transactionAddonControllerDelete(deleteTransactionAddonDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditTransactionAddonDto} editTransactionAddonDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionAddonApi
   */
  public transactionAddonControllerEdit(
    editTransactionAddonDto: EditTransactionAddonDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionAddonApiFp(this.configuration)
      .transactionAddonControllerEdit(editTransactionAddonDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionAddonApi
   */
  public transactionAddonControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionAddonApiFp(this.configuration)
      .transactionAddonControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionServiceApi - axios parameter creator
 * @export
 */
export const TransactionServiceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerCheckout: async (
      deleteTransactionServiceDto: DeleteTransactionServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionServiceDto' is not null or undefined
      assertParamExists(
        "transactionServiceControllerCheckout",
        "deleteTransactionServiceDto",
        deleteTransactionServiceDto
      );
      const localVarPath = `/api/v1/transaction-service/checkout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateTransactionServiceDto} createTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerCreate: async (
      createTransactionServiceDto: CreateTransactionServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createTransactionServiceDto' is not null or undefined
      assertParamExists(
        "transactionServiceControllerCreate",
        "createTransactionServiceDto",
        createTransactionServiceDto
      );
      const localVarPath = `/api/v1/transaction-service/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTransactionServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerDelete: async (
      deleteTransactionServiceDto: DeleteTransactionServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionServiceDto' is not null or undefined
      assertParamExists(
        "transactionServiceControllerDelete",
        "deleteTransactionServiceDto",
        deleteTransactionServiceDto
      );
      const localVarPath = `/api/v1/transaction-service/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditTransactionServiceDto} editTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerEdit: async (
      editTransactionServiceDto: EditTransactionServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editTransactionServiceDto' is not null or undefined
      assertParamExists(
        "transactionServiceControllerEdit",
        "editTransactionServiceDto",
        editTransactionServiceDto
      );
      const localVarPath = `/api/v1/transaction-service/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editTransactionServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/transaction-service/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionServiceApi - functional programming interface
 * @export
 */
export const TransactionServiceApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    TransactionServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionServiceControllerCheckout(
      deleteTransactionServiceDto: DeleteTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionServiceControllerCheckout(
          deleteTransactionServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionServiceApi.transactionServiceControllerCheckout"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateTransactionServiceDto} createTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionServiceControllerCreate(
      createTransactionServiceDto: CreateTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionServiceControllerCreate(
          createTransactionServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionServiceApi.transactionServiceControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionServiceControllerDelete(
      deleteTransactionServiceDto: DeleteTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionServiceControllerDelete(
          deleteTransactionServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionServiceApi.transactionServiceControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditTransactionServiceDto} editTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionServiceControllerEdit(
      editTransactionServiceDto: EditTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionServiceControllerEdit(
          editTransactionServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionServiceApi.transactionServiceControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionServiceControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TransactionServiceControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionServiceControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionServiceApi.transactionServiceControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TransactionServiceApi - factory interface
 * @export
 */
export const TransactionServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionServiceApiFp(configuration);
  return {
    /**
     *
     * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerCheckout(
      deleteTransactionServiceDto: DeleteTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionServiceControllerCheckout(
          deleteTransactionServiceDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateTransactionServiceDto} createTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerCreate(
      createTransactionServiceDto: CreateTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionServiceControllerCreate(
          createTransactionServiceDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerDelete(
      deleteTransactionServiceDto: DeleteTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionServiceControllerDelete(
          deleteTransactionServiceDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditTransactionServiceDto} editTransactionServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerEdit(
      editTransactionServiceDto: EditTransactionServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionServiceControllerEdit(editTransactionServiceDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionServiceControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TransactionServiceControllerGet200Response> {
      return localVarFp
        .transactionServiceControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionServiceApi - object-oriented interface
 * @export
 * @class TransactionServiceApi
 * @extends {BaseAPI}
 */
export class TransactionServiceApi extends BaseAPI {
  /**
   *
   * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionServiceApi
   */
  public transactionServiceControllerCheckout(
    deleteTransactionServiceDto: DeleteTransactionServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionServiceApiFp(this.configuration)
      .transactionServiceControllerCheckout(
        deleteTransactionServiceDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateTransactionServiceDto} createTransactionServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionServiceApi
   */
  public transactionServiceControllerCreate(
    createTransactionServiceDto: CreateTransactionServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionServiceApiFp(this.configuration)
      .transactionServiceControllerCreate(createTransactionServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTransactionServiceDto} deleteTransactionServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionServiceApi
   */
  public transactionServiceControllerDelete(
    deleteTransactionServiceDto: DeleteTransactionServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionServiceApiFp(this.configuration)
      .transactionServiceControllerDelete(deleteTransactionServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditTransactionServiceDto} editTransactionServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionServiceApi
   */
  public transactionServiceControllerEdit(
    editTransactionServiceDto: EditTransactionServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionServiceApiFp(this.configuration)
      .transactionServiceControllerEdit(editTransactionServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionServiceApi
   */
  public transactionServiceControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionServiceApiFp(this.configuration)
      .transactionServiceControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionWaiverApi - axios parameter creator
 * @export
 */
export const TransactionWaiverApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateTransactionWaiverBaseDto} waiver
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerCreate: async (
      waiver: CreateTransactionWaiverBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'waiver' is not null or undefined
      assertParamExists("transactionWaiverControllerCreate", "waiver", waiver);
      const localVarPath = `/api/v1/transaction-waiver/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (waiver !== undefined) {
        localVarFormParams.append("waiver", JSON.stringify(waiver));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTransactionWaiverDto} deleteTransactionWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerDelete: async (
      deleteTransactionWaiverDto: DeleteTransactionWaiverDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTransactionWaiverDto' is not null or undefined
      assertParamExists(
        "transactionWaiverControllerDelete",
        "deleteTransactionWaiverDto",
        deleteTransactionWaiverDto
      );
      const localVarPath = `/api/v1/transaction-waiver/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTransactionWaiverDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditTransactionWaiverBaseDto} waiver
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerEdit: async (
      waiver: EditTransactionWaiverBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'waiver' is not null or undefined
      assertParamExists("transactionWaiverControllerEdit", "waiver", waiver);
      const localVarPath = `/api/v1/transaction-waiver/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (waiver !== undefined) {
        localVarFormParams.append("waiver", JSON.stringify(waiver));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/transaction-waiver/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionWaiverApi - functional programming interface
 * @export
 */
export const TransactionWaiverApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TransactionWaiverApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateTransactionWaiverBaseDto} waiver
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionWaiverControllerCreate(
      waiver: CreateTransactionWaiverBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionWaiverControllerCreate(
          waiver,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionWaiverApi.transactionWaiverControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTransactionWaiverDto} deleteTransactionWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionWaiverControllerDelete(
      deleteTransactionWaiverDto: DeleteTransactionWaiverDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionWaiverControllerDelete(
          deleteTransactionWaiverDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionWaiverApi.transactionWaiverControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditTransactionWaiverBaseDto} waiver
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionWaiverControllerEdit(
      waiver: EditTransactionWaiverBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionWaiverControllerEdit(
          waiver,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionWaiverApi.transactionWaiverControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionWaiverControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TransactionWaiverControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionWaiverControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TransactionWaiverApi.transactionWaiverControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TransactionWaiverApi - factory interface
 * @export
 */
export const TransactionWaiverApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionWaiverApiFp(configuration);
  return {
    /**
     *
     * @param {CreateTransactionWaiverBaseDto} waiver
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerCreate(
      waiver: CreateTransactionWaiverBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionWaiverControllerCreate(waiver, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTransactionWaiverDto} deleteTransactionWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerDelete(
      deleteTransactionWaiverDto: DeleteTransactionWaiverDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionWaiverControllerDelete(deleteTransactionWaiverDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditTransactionWaiverBaseDto} waiver
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerEdit(
      waiver: EditTransactionWaiverBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .transactionWaiverControllerEdit(waiver, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionWaiverControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TransactionWaiverControllerGet200Response> {
      return localVarFp
        .transactionWaiverControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionWaiverApi - object-oriented interface
 * @export
 * @class TransactionWaiverApi
 * @extends {BaseAPI}
 */
export class TransactionWaiverApi extends BaseAPI {
  /**
   *
   * @param {CreateTransactionWaiverBaseDto} waiver
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionWaiverApi
   */
  public transactionWaiverControllerCreate(
    waiver: CreateTransactionWaiverBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionWaiverApiFp(this.configuration)
      .transactionWaiverControllerCreate(waiver, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTransactionWaiverDto} deleteTransactionWaiverDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionWaiverApi
   */
  public transactionWaiverControllerDelete(
    deleteTransactionWaiverDto: DeleteTransactionWaiverDto,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionWaiverApiFp(this.configuration)
      .transactionWaiverControllerDelete(deleteTransactionWaiverDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditTransactionWaiverBaseDto} waiver
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionWaiverApi
   */
  public transactionWaiverControllerEdit(
    waiver: EditTransactionWaiverBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionWaiverApiFp(this.configuration)
      .transactionWaiverControllerEdit(waiver, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionWaiverApi
   */
  public transactionWaiverControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TransactionWaiverApiFp(this.configuration)
      .transactionWaiverControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityAttachmentTypeApi - axios parameter creator
 * @export
 */
export const UtilityAttachmentTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerCreate: async (
      createAttachmentTypeDto: CreateAttachmentTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createAttachmentTypeDto' is not null or undefined
      assertParamExists(
        "utilAttachmentTypeControllerCreate",
        "createAttachmentTypeDto",
        createAttachmentTypeDto
      );
      const localVarPath = `/api/v1/util-attachment-type/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAttachmentTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerDelete: async (
      deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteAttachmentTypeDto' is not null or undefined
      assertParamExists(
        "utilAttachmentTypeControllerDelete",
        "deleteAttachmentTypeDto",
        deleteAttachmentTypeDto
      );
      const localVarPath = `/api/v1/util-attachment-type/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteAttachmentTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditAttachmentTypeDto} editAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerEdit: async (
      editAttachmentTypeDto: EditAttachmentTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editAttachmentTypeDto' is not null or undefined
      assertParamExists(
        "utilAttachmentTypeControllerEdit",
        "editAttachmentTypeDto",
        editAttachmentTypeDto
      );
      const localVarPath = `/api/v1/util-attachment-type/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editAttachmentTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-attachment-type/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityAttachmentTypeApi - functional programming interface
 * @export
 */
export const UtilityAttachmentTypeApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    UtilityAttachmentTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerCreate(
      createAttachmentTypeDto: CreateAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerCreate(
          createAttachmentTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerDelete(
      deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerDelete(
          deleteAttachmentTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditAttachmentTypeDto} editAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerEdit(
      editAttachmentTypeDto: EditAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerEdit(
          editAttachmentTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilAttachmentTypeControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityAttachmentTypeApi - factory interface
 * @export
 */
export const UtilityAttachmentTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityAttachmentTypeApiFp(configuration);
  return {
    /**
     *
     * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerCreate(
      createAttachmentTypeDto: CreateAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilAttachmentTypeControllerCreate(createAttachmentTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerDelete(
      deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditAttachmentTypeDto} editAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerEdit(
      editAttachmentTypeDto: EditAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilAttachmentTypeControllerEdit(editAttachmentTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilAttachmentTypeControllerGet200Response> {
      return localVarFp
        .utilAttachmentTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityAttachmentTypeApi - object-oriented interface
 * @export
 * @class UtilityAttachmentTypeApi
 * @extends {BaseAPI}
 */
export class UtilityAttachmentTypeApi extends BaseAPI {
  /**
   *
   * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerCreate(
    createAttachmentTypeDto: CreateAttachmentTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerCreate(createAttachmentTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerDelete(
    deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditAttachmentTypeDto} editAttachmentTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerEdit(
    editAttachmentTypeDto: EditAttachmentTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerEdit(editAttachmentTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityBranchApi - axios parameter creator
 * @export
 */
export const UtilityBranchApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateBranchDto} createBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerCreate: async (
      createBranchDto: CreateBranchDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createBranchDto' is not null or undefined
      assertParamExists(
        "utilBranchControllerCreate",
        "createBranchDto",
        createBranchDto
      );
      const localVarPath = `/api/v1/util-branch/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBranchDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteBranchDto} deleteBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerDelete: async (
      deleteBranchDto: DeleteBranchDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteBranchDto' is not null or undefined
      assertParamExists(
        "utilBranchControllerDelete",
        "deleteBranchDto",
        deleteBranchDto
      );
      const localVarPath = `/api/v1/util-branch/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteBranchDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditBranchDto} editBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerEdit: async (
      editBranchDto: EditBranchDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editBranchDto' is not null or undefined
      assertParamExists(
        "utilBranchControllerEdit",
        "editBranchDto",
        editBranchDto
      );
      const localVarPath = `/api/v1/util-branch/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editBranchDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-branch/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityBranchApi - functional programming interface
 * @export
 */
export const UtilityBranchApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityBranchApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateBranchDto} createBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilBranchControllerCreate(
      createBranchDto: CreateBranchDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilBranchControllerCreate(
          createBranchDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityBranchApi.utilBranchControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteBranchDto} deleteBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilBranchControllerDelete(
      deleteBranchDto: DeleteBranchDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilBranchControllerDelete(
          deleteBranchDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityBranchApi.utilBranchControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditBranchDto} editBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilBranchControllerEdit(
      editBranchDto: EditBranchDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilBranchControllerEdit(
          editBranchDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityBranchApi.utilBranchControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilBranchControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilBranchControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilBranchControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityBranchApi.utilBranchControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityBranchApi - factory interface
 * @export
 */
export const UtilityBranchApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityBranchApiFp(configuration);
  return {
    /**
     *
     * @param {CreateBranchDto} createBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerCreate(
      createBranchDto: CreateBranchDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilBranchControllerCreate(createBranchDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteBranchDto} deleteBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerDelete(
      deleteBranchDto: DeleteBranchDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilBranchControllerDelete(deleteBranchDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditBranchDto} editBranchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerEdit(
      editBranchDto: EditBranchDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilBranchControllerEdit(editBranchDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilBranchControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilBranchControllerGet200Response> {
      return localVarFp
        .utilBranchControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityBranchApi - object-oriented interface
 * @export
 * @class UtilityBranchApi
 * @extends {BaseAPI}
 */
export class UtilityBranchApi extends BaseAPI {
  /**
   *
   * @param {CreateBranchDto} createBranchDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityBranchApi
   */
  public utilBranchControllerCreate(
    createBranchDto: CreateBranchDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityBranchApiFp(this.configuration)
      .utilBranchControllerCreate(createBranchDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteBranchDto} deleteBranchDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityBranchApi
   */
  public utilBranchControllerDelete(
    deleteBranchDto: DeleteBranchDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityBranchApiFp(this.configuration)
      .utilBranchControllerDelete(deleteBranchDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditBranchDto} editBranchDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityBranchApi
   */
  public utilBranchControllerEdit(
    editBranchDto: EditBranchDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityBranchApiFp(this.configuration)
      .utilBranchControllerEdit(editBranchDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityBranchApi
   */
  public utilBranchControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityBranchApiFp(this.configuration)
      .utilBranchControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityConfigApi - axios parameter creator
 * @export
 */
export const UtilityConfigApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateConfigDto} createConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerCreate: async (
      createConfigDto: CreateConfigDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createConfigDto' is not null or undefined
      assertParamExists(
        "utilConfigControllerCreate",
        "createConfigDto",
        createConfigDto
      );
      const localVarPath = `/api/v1/util-config/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createConfigDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteConfigDto} deleteConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerDelete: async (
      deleteConfigDto: DeleteConfigDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteConfigDto' is not null or undefined
      assertParamExists(
        "utilConfigControllerDelete",
        "deleteConfigDto",
        deleteConfigDto
      );
      const localVarPath = `/api/v1/util-config/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteConfigDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditConfigDto} editConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerEdit: async (
      editConfigDto: EditConfigDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editConfigDto' is not null or undefined
      assertParamExists(
        "utilConfigControllerEdit",
        "editConfigDto",
        editConfigDto
      );
      const localVarPath = `/api/v1/util-config/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editConfigDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-config/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityConfigApi - functional programming interface
 * @export
 */
export const UtilityConfigApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityConfigApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateConfigDto} createConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerCreate(
      createConfigDto: CreateConfigDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerCreate(
          createConfigDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteConfigDto} deleteConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerDelete(
      deleteConfigDto: DeleteConfigDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerDelete(
          deleteConfigDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditConfigDto} editConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerEdit(
      editConfigDto: EditConfigDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerEdit(
          editConfigDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilConfigControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityConfigApi - factory interface
 * @export
 */
export const UtilityConfigApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityConfigApiFp(configuration);
  return {
    /**
     *
     * @param {CreateConfigDto} createConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerCreate(
      createConfigDto: CreateConfigDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilConfigControllerCreate(createConfigDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteConfigDto} deleteConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerDelete(
      deleteConfigDto: DeleteConfigDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilConfigControllerDelete(deleteConfigDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditConfigDto} editConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerEdit(
      editConfigDto: EditConfigDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilConfigControllerEdit(editConfigDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilConfigControllerGet200Response> {
      return localVarFp
        .utilConfigControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityConfigApi - object-oriented interface
 * @export
 * @class UtilityConfigApi
 * @extends {BaseAPI}
 */
export class UtilityConfigApi extends BaseAPI {
  /**
   *
   * @param {CreateConfigDto} createConfigDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerCreate(
    createConfigDto: CreateConfigDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerCreate(createConfigDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteConfigDto} deleteConfigDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerDelete(
    deleteConfigDto: DeleteConfigDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerDelete(deleteConfigDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditConfigDto} editConfigDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerEdit(
    editConfigDto: EditConfigDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerEdit(editConfigDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityItemApi - axios parameter creator
 * @export
 */
export const UtilityItemApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateItemDto} createItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerCreate: async (
      createItemDto: CreateItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createItemDto' is not null or undefined
      assertParamExists(
        "utilItemControllerCreate",
        "createItemDto",
        createItemDto
      );
      const localVarPath = `/api/v1/util-item/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteItemDto} deleteItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerDelete: async (
      deleteItemDto: DeleteItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteItemDto' is not null or undefined
      assertParamExists(
        "utilItemControllerDelete",
        "deleteItemDto",
        deleteItemDto
      );
      const localVarPath = `/api/v1/util-item/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditItemDto} editItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerEdit: async (
      editItemDto: EditItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editItemDto' is not null or undefined
      assertParamExists("utilItemControllerEdit", "editItemDto", editItemDto);
      const localVarPath = `/api/v1/util-item/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-item/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityItemApi - functional programming interface
 * @export
 */
export const UtilityItemApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityItemApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateItemDto} createItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerCreate(
      createItemDto: CreateItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerCreate(
          createItemDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteItemDto} deleteItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerDelete(
      deleteItemDto: DeleteItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerDelete(
          deleteItemDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditItemDto} editItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerEdit(
      editItemDto: EditItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerEdit(
          editItemDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilItemControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityItemApi - factory interface
 * @export
 */
export const UtilityItemApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityItemApiFp(configuration);
  return {
    /**
     *
     * @param {CreateItemDto} createItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerCreate(
      createItemDto: CreateItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilItemControllerCreate(createItemDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteItemDto} deleteItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerDelete(
      deleteItemDto: DeleteItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilItemControllerDelete(deleteItemDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditItemDto} editItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerEdit(
      editItemDto: EditItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilItemControllerEdit(editItemDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilItemControllerGet200Response> {
      return localVarFp
        .utilItemControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityItemApi - object-oriented interface
 * @export
 * @class UtilityItemApi
 * @extends {BaseAPI}
 */
export class UtilityItemApi extends BaseAPI {
  /**
   *
   * @param {CreateItemDto} createItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerCreate(
    createItemDto: CreateItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerCreate(createItemDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteItemDto} deleteItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerDelete(
    deleteItemDto: DeleteItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerDelete(deleteItemDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditItemDto} editItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerEdit(
    editItemDto: EditItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerEdit(editItemDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityRequestTypeApi - axios parameter creator
 * @export
 */
export const UtilityRequestTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateRequestTypeDto} createRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerCreate: async (
      createRequestTypeDto: CreateRequestTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createRequestTypeDto' is not null or undefined
      assertParamExists(
        "utilRequestTypeControllerCreate",
        "createRequestTypeDto",
        createRequestTypeDto
      );
      const localVarPath = `/api/v1/util-request-type/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRequestTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteRequestTypeDto} deleteRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerDelete: async (
      deleteRequestTypeDto: DeleteRequestTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteRequestTypeDto' is not null or undefined
      assertParamExists(
        "utilRequestTypeControllerDelete",
        "deleteRequestTypeDto",
        deleteRequestTypeDto
      );
      const localVarPath = `/api/v1/util-request-type/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRequestTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditRequestTypeDto} editRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerEdit: async (
      editRequestTypeDto: EditRequestTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editRequestTypeDto' is not null or undefined
      assertParamExists(
        "utilRequestTypeControllerEdit",
        "editRequestTypeDto",
        editRequestTypeDto
      );
      const localVarPath = `/api/v1/util-request-type/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editRequestTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-request-type/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityRequestTypeApi - functional programming interface
 * @export
 */
export const UtilityRequestTypeApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    UtilityRequestTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateRequestTypeDto} createRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRequestTypeControllerCreate(
      createRequestTypeDto: CreateRequestTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRequestTypeControllerCreate(
          createRequestTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityRequestTypeApi.utilRequestTypeControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteRequestTypeDto} deleteRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRequestTypeControllerDelete(
      deleteRequestTypeDto: DeleteRequestTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRequestTypeControllerDelete(
          deleteRequestTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityRequestTypeApi.utilRequestTypeControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditRequestTypeDto} editRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRequestTypeControllerEdit(
      editRequestTypeDto: EditRequestTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRequestTypeControllerEdit(
          editRequestTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityRequestTypeApi.utilRequestTypeControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRequestTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilRequestTypeControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRequestTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityRequestTypeApi.utilRequestTypeControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityRequestTypeApi - factory interface
 * @export
 */
export const UtilityRequestTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityRequestTypeApiFp(configuration);
  return {
    /**
     *
     * @param {CreateRequestTypeDto} createRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerCreate(
      createRequestTypeDto: CreateRequestTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRequestTypeControllerCreate(createRequestTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteRequestTypeDto} deleteRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerDelete(
      deleteRequestTypeDto: DeleteRequestTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRequestTypeControllerDelete(deleteRequestTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditRequestTypeDto} editRequestTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerEdit(
      editRequestTypeDto: EditRequestTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRequestTypeControllerEdit(editRequestTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRequestTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilRequestTypeControllerGet200Response> {
      return localVarFp
        .utilRequestTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityRequestTypeApi - object-oriented interface
 * @export
 * @class UtilityRequestTypeApi
 * @extends {BaseAPI}
 */
export class UtilityRequestTypeApi extends BaseAPI {
  /**
   *
   * @param {CreateRequestTypeDto} createRequestTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRequestTypeApi
   */
  public utilRequestTypeControllerCreate(
    createRequestTypeDto: CreateRequestTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRequestTypeApiFp(this.configuration)
      .utilRequestTypeControllerCreate(createRequestTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteRequestTypeDto} deleteRequestTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRequestTypeApi
   */
  public utilRequestTypeControllerDelete(
    deleteRequestTypeDto: DeleteRequestTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRequestTypeApiFp(this.configuration)
      .utilRequestTypeControllerDelete(deleteRequestTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditRequestTypeDto} editRequestTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRequestTypeApi
   */
  public utilRequestTypeControllerEdit(
    editRequestTypeDto: EditRequestTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRequestTypeApiFp(this.configuration)
      .utilRequestTypeControllerEdit(editRequestTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRequestTypeApi
   */
  public utilRequestTypeControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRequestTypeApiFp(this.configuration)
      .utilRequestTypeControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityRoleApi - axios parameter creator
 * @export
 */
export const UtilityRoleApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerCreate: async (
      createRoleDto: CreateRoleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createRoleDto' is not null or undefined
      assertParamExists(
        "utilRoleControllerCreate",
        "createRoleDto",
        createRoleDto
      );
      const localVarPath = `/api/v1/util-role/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRoleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteRoleDto} deleteRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerDelete: async (
      deleteRoleDto: DeleteRoleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteRoleDto' is not null or undefined
      assertParamExists(
        "utilRoleControllerDelete",
        "deleteRoleDto",
        deleteRoleDto
      );
      const localVarPath = `/api/v1/util-role/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRoleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditRoleDto} editRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerEdit: async (
      editRoleDto: EditRoleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editRoleDto' is not null or undefined
      assertParamExists("utilRoleControllerEdit", "editRoleDto", editRoleDto);
      const localVarPath = `/api/v1/util-role/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editRoleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-role/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityRoleApi - functional programming interface
 * @export
 */
export const UtilityRoleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityRoleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerCreate(
      createRoleDto: CreateRoleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerCreate(
          createRoleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteRoleDto} deleteRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerDelete(
      deleteRoleDto: DeleteRoleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerDelete(
          deleteRoleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditRoleDto} editRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerEdit(
      editRoleDto: EditRoleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerEdit(
          editRoleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilRoleControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityRoleApi - factory interface
 * @export
 */
export const UtilityRoleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityRoleApiFp(configuration);
  return {
    /**
     *
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerCreate(
      createRoleDto: CreateRoleDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRoleControllerCreate(createRoleDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteRoleDto} deleteRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerDelete(
      deleteRoleDto: DeleteRoleDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRoleControllerDelete(deleteRoleDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditRoleDto} editRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerEdit(
      editRoleDto: EditRoleDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRoleControllerEdit(editRoleDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilRoleControllerGet200Response> {
      return localVarFp
        .utilRoleControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityRoleApi - object-oriented interface
 * @export
 * @class UtilityRoleApi
 * @extends {BaseAPI}
 */
export class UtilityRoleApi extends BaseAPI {
  /**
   *
   * @param {CreateRoleDto} createRoleDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerCreate(
    createRoleDto: CreateRoleDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerCreate(createRoleDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteRoleDto} deleteRoleDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerDelete(
    deleteRoleDto: DeleteRoleDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerDelete(deleteRoleDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditRoleDto} editRoleDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerEdit(
    editRoleDto: EditRoleDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerEdit(editRoleDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityServiceApi - axios parameter creator
 * @export
 */
export const UtilityServiceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateServiceDto} createServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerCreate: async (
      createServiceDto: CreateServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createServiceDto' is not null or undefined
      assertParamExists(
        "utilServiceControllerCreate",
        "createServiceDto",
        createServiceDto
      );
      const localVarPath = `/api/v1/util-service/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteServiceDto} deleteServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerDelete: async (
      deleteServiceDto: DeleteServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteServiceDto' is not null or undefined
      assertParamExists(
        "utilServiceControllerDelete",
        "deleteServiceDto",
        deleteServiceDto
      );
      const localVarPath = `/api/v1/util-service/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditServiceDto} editServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerEdit: async (
      editServiceDto: EditServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editServiceDto' is not null or undefined
      assertParamExists(
        "utilServiceControllerEdit",
        "editServiceDto",
        editServiceDto
      );
      const localVarPath = `/api/v1/util-service/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-service/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityServiceApi - functional programming interface
 * @export
 */
export const UtilityServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateServiceDto} createServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerCreate(
      createServiceDto: CreateServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerCreate(
          createServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteServiceDto} deleteServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerDelete(
      deleteServiceDto: DeleteServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerDelete(
          deleteServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditServiceDto} editServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerEdit(
      editServiceDto: EditServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerEdit(
          editServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilServiceControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityServiceApi - factory interface
 * @export
 */
export const UtilityServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityServiceApiFp(configuration);
  return {
    /**
     *
     * @param {CreateServiceDto} createServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerCreate(
      createServiceDto: CreateServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilServiceControllerCreate(createServiceDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteServiceDto} deleteServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerDelete(
      deleteServiceDto: DeleteServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilServiceControllerDelete(deleteServiceDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditServiceDto} editServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerEdit(
      editServiceDto: EditServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilServiceControllerEdit(editServiceDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilServiceControllerGet200Response> {
      return localVarFp
        .utilServiceControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityServiceApi - object-oriented interface
 * @export
 * @class UtilityServiceApi
 * @extends {BaseAPI}
 */
export class UtilityServiceApi extends BaseAPI {
  /**
   *
   * @param {CreateServiceDto} createServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerCreate(
    createServiceDto: CreateServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerCreate(createServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteServiceDto} deleteServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerDelete(
    deleteServiceDto: DeleteServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerDelete(deleteServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditServiceDto} editServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerEdit(
    editServiceDto: EditServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerEdit(editServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityStatusApi - axios parameter creator
 * @export
 */
export const UtilityStatusApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateStatusDto} createStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerCreate: async (
      createStatusDto: CreateStatusDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createStatusDto' is not null or undefined
      assertParamExists(
        "utilStatusControllerCreate",
        "createStatusDto",
        createStatusDto
      );
      const localVarPath = `/api/v1/util-status/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteStatusDto} deleteStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerDelete: async (
      deleteStatusDto: DeleteStatusDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteStatusDto' is not null or undefined
      assertParamExists(
        "utilStatusControllerDelete",
        "deleteStatusDto",
        deleteStatusDto
      );
      const localVarPath = `/api/v1/util-status/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditStatusDto} editStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerEdit: async (
      editStatusDto: EditStatusDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editStatusDto' is not null or undefined
      assertParamExists(
        "utilStatusControllerEdit",
        "editStatusDto",
        editStatusDto
      );
      const localVarPath = `/api/v1/util-status/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-status/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityStatusApi - functional programming interface
 * @export
 */
export const UtilityStatusApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityStatusApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateStatusDto} createStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerCreate(
      createStatusDto: CreateStatusDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerCreate(
          createStatusDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteStatusDto} deleteStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerDelete(
      deleteStatusDto: DeleteStatusDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerDelete(
          deleteStatusDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditStatusDto} editStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerEdit(
      editStatusDto: EditStatusDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerEdit(
          editStatusDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilStatusControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityStatusApi - factory interface
 * @export
 */
export const UtilityStatusApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityStatusApiFp(configuration);
  return {
    /**
     *
     * @param {CreateStatusDto} createStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerCreate(
      createStatusDto: CreateStatusDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilStatusControllerCreate(createStatusDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteStatusDto} deleteStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerDelete(
      deleteStatusDto: DeleteStatusDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilStatusControllerDelete(deleteStatusDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditStatusDto} editStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerEdit(
      editStatusDto: EditStatusDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilStatusControllerEdit(editStatusDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilStatusControllerGet200Response> {
      return localVarFp
        .utilStatusControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityStatusApi - object-oriented interface
 * @export
 * @class UtilityStatusApi
 * @extends {BaseAPI}
 */
export class UtilityStatusApi extends BaseAPI {
  /**
   *
   * @param {CreateStatusDto} createStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerCreate(
    createStatusDto: CreateStatusDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerCreate(createStatusDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteStatusDto} deleteStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerDelete(
    deleteStatusDto: DeleteStatusDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerDelete(deleteStatusDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditStatusDto} editStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerEdit(
    editStatusDto: EditStatusDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerEdit(editStatusDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WaiverApi - axios parameter creator
 * @export
 */
export const WaiverApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateWaiverDto} createWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerCreate: async (
      createWaiverDto: CreateWaiverDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createWaiverDto' is not null or undefined
      assertParamExists(
        "waiverControllerCreate",
        "createWaiverDto",
        createWaiverDto
      );
      const localVarPath = `/api/v1/wavier/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createWaiverDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteWaiverDto} deleteWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerDelete: async (
      deleteWaiverDto: DeleteWaiverDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteWaiverDto' is not null or undefined
      assertParamExists(
        "waiverControllerDelete",
        "deleteWaiverDto",
        deleteWaiverDto
      );
      const localVarPath = `/api/v1/wavier/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteWaiverDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditWaiverDto} editWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerEdit: async (
      editWaiverDto: EditWaiverDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editWaiverDto' is not null or undefined
      assertParamExists("waiverControllerEdit", "editWaiverDto", editWaiverDto);
      const localVarPath = `/api/v1/wavier/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editWaiverDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/wavier/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WaiverApi - functional programming interface
 * @export
 */
export const WaiverApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WaiverApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateWaiverDto} createWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerCreate(
      createWaiverDto: CreateWaiverDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerCreate(
          createWaiverDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteWaiverDto} deleteWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerDelete(
      deleteWaiverDto: DeleteWaiverDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerDelete(
          deleteWaiverDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditWaiverDto} editWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerEdit(
      editWaiverDto: EditWaiverDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerEdit(
          editWaiverDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<WaiverControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * WaiverApi - factory interface
 * @export
 */
export const WaiverApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = WaiverApiFp(configuration);
  return {
    /**
     *
     * @param {CreateWaiverDto} createWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerCreate(
      createWaiverDto: CreateWaiverDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .waiverControllerCreate(createWaiverDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteWaiverDto} deleteWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerDelete(
      deleteWaiverDto: DeleteWaiverDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .waiverControllerDelete(deleteWaiverDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditWaiverDto} editWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerEdit(
      editWaiverDto: EditWaiverDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .waiverControllerEdit(editWaiverDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WaiverControllerGet200Response> {
      return localVarFp
        .waiverControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WaiverApi - object-oriented interface
 * @export
 * @class WaiverApi
 * @extends {BaseAPI}
 */
export class WaiverApi extends BaseAPI {
  /**
   *
   * @param {CreateWaiverDto} createWaiverDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerCreate(
    createWaiverDto: CreateWaiverDto,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerCreate(createWaiverDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteWaiverDto} deleteWaiverDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerDelete(
    deleteWaiverDto: DeleteWaiverDto,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerDelete(deleteWaiverDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditWaiverDto} editWaiverDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerEdit(
    editWaiverDto: EditWaiverDto,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerEdit(editWaiverDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
